import type { SentenceBank } from "../types";

export const SENTENCE_BANK: SentenceBank = {
  short: [
    // A sentences
    "I have a cat",
    "She has a dog",
    "Take a break",
    "Make a plan",
    "What a day",
    "Call a taxi",
    "Read a book",
    "Find a way",
    "Buy a car",
    "Eat an apple",
    "Ask a question",
    "Draw a picture",
    "Catch a ball",
    "Plant a tree",
    "Start a fire",
    "Watch a movie",
    "Take a walk",
    "Make a cake",
    "Play a game",
    "Visit a park",

    // I sentences
    "I like tea",
    "I can swim",
    "I am tired",
    "I will go",
    "I see birds",
    "I need help",
    "I feel happy",
    "I want food",
    "I know this",
    "I hear music",
    "I love pizza",
    "I speak English",
    "I think fast",
    "I drive cars",
    "I write stories",
    "I build things",
    "I paint walls",
    "I sing songs",
    "I dance well",
    "I study hard",

    // U sentences
    "The sun is up",
    "Put it under there",
    "Just use this",
    "Cup of water",
    "Turn up the music",
    "Hunt for treasure",
    "Study for the test",
    "Run up the hill",
    "Cut up the fruit",
    "Fun under the sun",
    "Jump up high",
    "Dust under the bed",
    "Lunch is ready",
    "Brush your teeth",
    "Trust your gut",
    "Push the button",
    "Pull up the covers",
    "Butter on toast",
    "Summer is coming",
    "Thunder in the sky",

    // E sentences
    "We like pets",
    "The red pen",
    "Get some rest",
    "Set the table",
    "Let me help",
    "Tell me more",
    "Best friend ever",
    "Next week maybe",
    "Keep the change",
    "Send me email",
    "Enter the room",
    "Seven green trees",
    "Never give up",
    "Better late than never",
    "Remember this moment",
    "Every single day",
    "Hello there friend",
    "Welcome to our home",
    "Check your pocket",
    "Sleep well tonight",

    // O sentences
    "Go to work",
    "Open the door",
    "Hold on tight",
    "Roll over there",
    "Show me how",
    "More hot coffee",
    "Hope for the best",
    "Come home soon",
    "Love conquers all",
    "Move over please",
    "Throw the ball",
    "Know your limits",
    "Follow your dreams",
    "Tomorrow is Monday",
    "Hello old friend",
    "Close your eyes",
    "Vote for change",
    "Home sweet home",
    "Code on computer",
    "Store more items",

    // KA/CA sentences
    "Take care now",
    "Make a cake",
    "Can you call",
    "Park the car",
    "Cook some rice",
    "Pick a card",
    "Back to school",
    "Pack your case",
    "Check your camera",
    "Track your progress",
    "Jack likes candy",
    "Rock and roll",
    "Quick car ride",
    "Black cat sleeping",
    "Stack of cards",
    "Ask the captain",
    "Crack the code",
    "Pick my favorite",
    "Duck in water",
    "Kick the ball",

    // KI sentences
    "Keep it simple",
    "Pick it up",
    "Quick kiss goodbye",
    "Kick it hard",
    "Think it through",
    "Skip the meeting",
    "Stick with me",
    "Drink milk daily",
    "Link these pages",
    "Risk it all",
    "Fix the kitchen",
    "Mix it well",
    "Thick winter coat",
    "Click the button",
    "Trick or treat",
    "Pink kitchen walls",
    "Sink full of dishes",
    "King of the hill",
    "Ring the bell",
    "Bring me coffee",

    // KU sentences
    "Look up there",
    "Book your trip",
    "Cook lunch today",
    "Take a look",
    "Hook line sinker",
    "Shook hands firmly",
    "Brook runs fast",
    "Crook got caught",
    "Duke loves music",
    "Luke plays guitar",
    "Fluke or skill",
    "Puke feeling sick",
    "Rebuke harsh words",
    "Nuke in microwave",
    "Juke box playing",
    "Puck hits goal",
    "Buck runs wild",
    "Luck be lady",
    "Muck and mud",
    "Stuck in traffic",

    // KE sentences
    "Keep me safe",
    "Make me smile",
    "Take me home",
    "Bake me cookies",
    "Wake me early",
    "Shake me gently",
    "Joke keeps coming",
    "Broke my heart",
    "Smoke detector beeping",
    "Poke me gently",
    "Spoke very softly",
    "Choke on water",
    "Yoke of oxen",
    "Stroke the cat",
    "Invoke your rights",
    "Revoke the license",
    "Evoke strong feelings",
    "Provoke no one",
    "Like me please",
    "Fake jewelry store",

    // KO sentences
    "Go back home",
    "So very cold",
    "No more time",
    "Come over here",
    "Hope for tomorrow",
    "Cope with stress",
    "Rope hanging down",
    "Slope getting steep",
    "Scope of work",
    "Dope not smart",
    "Lope like horse",
    "Mope around house",
    "Pope visits Rome",
    "Nope not today",
    "Elope to Vegas",
    "Envelope needs stamp",
    "Horoscope says good",
    "Microscope shows tiny",
    "Telescope shows stars",
    "Stethoscope hears heart",

    // SA sentences
    "Say hello please",
    "Sand on beach",
    "Salt in water",
    "Same old story",
    "Save some money",
    "Safe at home",
    "Sad but true",
    "Sat down quietly",
    "Saw the sunrise",
    "Saturday is fun",
    "Sample some food",
    "Salmon swimming upstream",
    "Salad for lunch",
    "Satisfy your hunger",
    "Satellite in space",
    "Sabotage the plan",
    "Safari adventure trip",
    "Saga continues on",
    "Sage wise advice",
    "Santa comes tonight",

    // SHI sentences
    "She likes music",
    "Shine bright star",
    "Ship sails away",
    "Shift your weight",
    "Shirt is blue",
    "Shiny new car",
    "Sheep in field",
    "Sheet music stand",
    "Shell on shore",
    "Shelter from rain",
    "Shepherd watches flock",
    "Sheriff keeps peace",
    "Sherbet tastes sweet",
    "Sherry wine glass",
    "Shield from harm",
    "Shimmer in light",
    "Shiver from cold",
    "Shock wave hit",
    "Shoe fits well",
    "Shop for groceries",

    // SU sentences
    "Sun shines bright",
    "Such a day",
    "Sure thing buddy",
    "Summer vacation fun",
    "Sunday church service",
    "Sudden loud noise",
    "Suffer no more",
    "Sugar tastes sweet",
    "Suggest good idea",
    "Suit looks nice",
    "Suitcase packed full",
    "Summit mountain peak",
    "Summon your courage",
    "Super hero saves",
    "Supply and demand",
    "Support your team",
    "Suppose we try",
    "Supreme court rules",
    "Surface looks smooth",
    "Surgery went well",

    // SE sentences
    "See you later",
    "Send me message",
    "Sell your car",
    "Set the table",
    "Seven days week",
    "Several good options",
    "Sew the button",
    "Search for truth",
    "Season with salt",
    "Seat belt buckled",
    "Second chance given",
    "Secret safe place",
    "Section of book",
    "Security guard watches",
    "Seed grows plant",
    "Seek and find",
    "Seem very happy",
    "Select best option",
    "Senate votes today",
    "Senior citizen discount",

    // SO sentences
    "So very tired",
    "Soap and water",
    "Soar like eagle",
    "Soccer ball kicked",
    "Social media posts",
    "Society needs change",
    "Sociology class meets",
    "Socket needs plug",
    "Soda pop fizzes",
    "Sofa in living",
    "Soft warm blanket",
    "Soil grows plants",
    "Solar power works",
    "Soldier stands guard",
    "Sole of shoe",
    "Solid rock foundation",
    "Solution to problem",
    "Someone knocks door",
    "Song sounds beautiful",
    "Soon we leave",

    // TA sentences
    "Take me there",
    "Talk to me",
    "Tall green tree",
    "Tape the box",
    "Taste so good",
    "Tax return filed",
    "Taxi cab waiting",
    "Tea time now",
    "Teach me how",
    "Team wins game",
    "Tear in fabric",
    "Technical support helps",
    "Television show starts",
    "Tell the truth",
    "Temperature rising fast",
    "Tent keeps dry",
    "Terrible storm coming",
    "Test your knowledge",
    "Thank you much",
    "Theater play begins",

    // CHI sentences
    "Child loves candy",
    "Chicken soup hot",
    "China plate broke",
    "Chip off block",
    "Choice is yours",
    "Chop the wood",
    "Church bells ring",
    "Circle around town",
    "City lights bright",
    "Class starts soon",
    "Clean your room",
    "Clear blue sky",
    "Click mouse button",
    "Climb the ladder",
    "Clock strikes twelve",
    "Close the door",
    "Cloud covers sun",
    "Coach teaches well",
    "Coast is clear",
    "Code works perfectly",

    // TSU sentences
    "Tsunami wave big",
    "Tuesday is busy",
    "Tube holds water",
    "Tune your guitar",
    "Turn left here",
    "Turtle swims slow",
    "Twelve noon exactly",
    "Twin brother sister",
    "Twist the cap",
    "Type your message",

    // TE sentences
    "Tell me more",
    "Test your skills",
    "Ten green bottles",
    "Team spirit strong",
    "Teacher helps students",
    "Technology advances fast",
    "Telephone rings loudly",
    "Television show funny",
    "Temperature feels cold",
    "Temporary job opening",
    "Tennis ball bounces",
    "Tent camping trip",
    "Terminal bus station",
    "Terrible weather today",
    "Territory needs exploring",
    "Text message received",
    "Theater performance amazing",
    "Therapy session helpful",
    "Thermometer reads high",
    "Ticket costs money",

    // TO sentences
    "To be continued",
    "Top of mountain",
    "Touch the sky",
    "Town square busy",
    "Toy store opens",
    "Track your package",
    "Traffic moves slow",
    "Train arrives late",
    "Travel the world",
    "Tree grows tall",
    "Truck carries load",
    "Trust your instincts",
    "Try your best",
    "Tunnel under river",
    "Turn the page",
    "Twelve months year",
    "Two plus two",
    "Type on keyboard",
    "Total amount due",
    "Tournament begins today",

    // NA sentences
    "Name your price",
    "Nation stands united",
    "Natural disaster strikes",
    "Nature photography beautiful",
    "Navigate the waters",
    "Navy ship sails",
    "Near the store",
    "Neat and tidy",
    "Necessary evil exists",
    "Neck feels sore",
    "Need more time",
    "Needle and thread",
    "Negative test results",
    "Neighbor helps out",
    "Network connection slow",
    "Never give up",
    "New car smells",
    "News report says",
    "Next week vacation",
    "Nice weather today",

    // NI sentences
    "Nice to meet",
    "Night sky stars",
    "Nine months pregnant",
    "Nobody home today",
    "Noise outside loud",
    "North wind blows",
    "Nose feels stuffy",
    "Note to self",
    "Nothing ventured gained",
    "Notice the difference",
    "November leaves fall",
    "Number one priority",
    "Nurse helps patients",
    "Nutrition facts label",

    // NU sentences
    "Nuclear power plant",
    "Nude art museum",
    "Number crunching time",
    "Numerous options available",
    "Nursery rhyme song",
    "Nut and bolt",
    "Nutrition label reading",

    // NE sentences
    "Never say never",
    "Next door neighbor",
    "New year resolution",
    "Need more coffee",
    "Net profit margins",
    "Nest egg savings",
    "News anchor reports",
    "Needle in haystack",
    "Negative space design",
    "Network television show",
    "Neutral ground meeting",
    "Nevertheless we continue",

    // NO sentences
    "No problem here",
    "North pole cold",
    "Note book paper",
    "November rain falls",
    "Now or never",
    "Nose knows best",
    "Nobody understands me",
    "Noise pollution bad",
    "Normal day routine",
    "Nothing special today",
    "Notice board full",
    "Novel idea works",
    "Nowhere to go",
    "Number one song",

    // HA sentences
    "Have a day",
    "Happy birthday today",
    "Hard work pays",
    "Hat on head",
    "Hate no one",
    "Haven safe place",
    "Hawk flies high",
    "Hay in barn",
    "Head and shoulders",
    "Health first priority",
    "Heart beats fast",
    "Heat wave coming",
    "Heavy rain falls",
    "Help your neighbor",
    "Here and there",
    "Hero saves day",
    "Hide and seek",
    "High mountain peak",
    "History repeats itself",
    "Home sweet home",

    // HI sentences
    "Hi there friend",
    "Hide and seek",
    "High five celebration",
    "Hill top view",
    "Hip hop music",
    "History lesson learned",
    "Hit the target",
    "Hobby keeps busy",
    "Hold your horses",
    "Hole in ground",
    "Holiday season approaches",
    "Hollow tree trunk",
    "Holy sacred ground",
    "Home run hit",
    "Honey bee buzzes",
    "Hope springs eternal",
    "Horse gallops fast",
    "Hospital emergency room",
    "Hotel room key",
    "House for sale",

    // FU sentences
    "Fun at park",
    "Full moon bright",
    "Future looks bright",
    "Funny joke told",
    "Fuel tank empty",
    "Function works well",
    "Fund raising event",
    "Fundamental truth revealed",
    "Furniture store sale",
    "Fury of storm",

    // HE sentences
    "He likes sports",
    "Help me please",
    "Here we go",
    "Heavy rain today",
    "Health is wealth",
    "Heart beats strong",
    "Heat wave coming",
    "Heaven on earth",
    "Hell breaks loose",
    "Helmet protects head",
    "Help arrives soon",
    "Herb garden grows",
    "Here comes trouble",
    "Hero saves day",
    "Hesitate no more",
    "Hey there buddy",
    "Hierarchy established clearly",
    "High expectations met",
    "Highway traffic jam",
    "Hill climbing exercise",

    // HO sentences
    "Hope for best",
    "Home sweet home",
    "Horse runs fast",
    "Hot summer day",
    "Hour passes quickly",
    "House needs repair",
    "How are you",
    "Holy sacred place",
    "Honest truth told",
    "Honor thy father",
    "Hook line sinker",
    "Horizon line straight",
    "Horror movie scary",
    "Hospital emergency ward",
    "Hotel room service",
    "Hobby horse rides",
    "Hockey game tonight",
    "Holiday vacation time",
    "Hollow sound echoes",
    "Homework assignment due",

    // MA sentences
    "Make me happy",
    "Many good options",
    "Map shows route",
    "March winds blow",
    "Market opens early",
    "Master your craft",
    "Match made heaven",
    "Matter of time",
    "May flowers bloom",
    "Mayor speaks tonight",
    "Meal tastes delicious",
    "Mean what say",
    "Measure twice cut",
    "Medical attention needed",
    "Meeting starts now",
    "Memory lane walk",
    "Message received loud",
    "Method works well",
    "Middle ground found",
    "Midnight strikes twelve",

    // MI sentences
    "Mind your business",
    "Milk and cookies",
    "Million dollar question",
    "Minute by minute",
    "Mirror shows reflection",
    "Mission accomplished successfully",
    "Mistake happens sometimes",
    "Mix it well",
    "Mobile phone rings",
    "Model behavior expected",
    "Modern art museum",
    "Moment of truth",
    "Monday morning blues",
    "Money talks loudly",
    "Monitor screen bright",
    "Month passes quickly",
    "Moon shines bright",
    "Morning coffee hot",
    "Mother knows best",
    "Mountain peak high",

    // MU sentences
    "Much ado nothing",
    "Mud puddle deep",
    "Multiple choice question",
    "Murder mystery novel",
    "Muscle memory works",
    "Museum closes early",
    "Music sounds beautiful",
    "Must try harder",
    "Mutual respect needed",
    "Mystery solved finally",

    // ME sentences
    "Meet me halfway",
    "Memory lane walk",
    "Menu looks good",
    "Message received clearly",
    "Metal detector beeps",
    "Method works perfectly",
    "Meter reads high",
    "Mexico trip planned",
    "Mickey mouse ears",
    "Middle school years",
    "Midnight snack time",
    "Military parade marches",
    "Milk chocolate melts",
    "Million people gathered",
    "Mind reading impossible",
    "Mineral water refreshing",
    "Minimum wage increase",
    "Minor league baseball",
    "Minute detail matters",
    "Mirror reflection shows",

    // MO sentences
    "More coffee please",
    "Morning sun rises",
    "Mother loves children",
    "Mountain climbing adventure",
    "Mouse runs fast",
    "Movie starts soon",
    "Money buys happiness",
    "Monday blues again",
    "Moon phases change",
    "Moral of story",
    "Motor runs smooth",
    "Mouth waters thinking",
    "Modern art gallery",
    "Moment of silence",
    "Monitor shows data",
    "Monopoly game night",
    "Monster truck rally",
    "Monument stands tall",
    "Mood changes quickly",
    "Mortgage payment due",

    // YA sentences
    "Yard sale today",
    "Year passes quickly",
    "Yellow taxi cab",
    "Yes we can",
    "Yesterday was fun",
    "Yoga class starts",
    "Young at heart",
    "Your turn now",
    "Yawn means tired",
    "Yacht sails away",

    // YU sentences
    "Yummy food here",
    "Yugoslavia no longer",

    // YO sentences
    "You are welcome",
    "Young people today",
    "Your choice matters",
    "Yoga helps relax",
    "Yesterday feels distant",
    "York city busy",
    "Youth hostel cheap",

    // Additional comprehensive short sentences for all translations
    "First place winner",
    "One step forward",
    "Two hands clap",
    "Second chance given",
    "Three wise men",
    "Third time charm",
    "Four leaf clover",
    "Five golden rings",
    "Six pack abs",
    "Seven deadly sins",
    "Eight ball pool",
    "Nine lives cat",
    "Ten commandments given",
    "Human rights matter",
    "Person of interest",
    "Big dreams achieved",
    "Large pizza order",
    "Great success story",
    "Day starts early",
    "Sun shines bright",
    "Japan loves culture",
    "Year passes quickly",
    "Age shows wisdom",
    "Exit through door",
    "Come out party",
    "Go out tonight",
    "Book reading time",
    "Origin of life",
    "Main course served",
    "Middle ground found",
    "Inside joke shared",
    "Center stage performance",
    "Child loves candy",
    "Offspring need care",
    "See the light",
    "Look both ways",
    "Watch your step",
    "Country music plays",
    "Nation stands united",
    "Above average score",
    "Up the ladder",
    "Top shelf quality",
    "Part of team",
    "Minute by minute",
    "Divide and conquer",
    "Life goes on",
    "Birth certificate required",
    "Raw fish sushi",
    "Go home now",
    "Conduct business meeting",
    "Line forms here",
    "Between the lines",
    "Interval training works",
    "Time flies fast",
    "Hour glass empty",
    "Spirit of adventure",
    "Mind over matter",
    "Feeling good today",
    "Woman of strength",
    "Female lion hunts",
    "Before sunrise prayer",
    "Front row seats",
    "Enter your password",
    "Put in effort",
    "Small town charm",
    "Little bird sings",
    "After work drinks",
    "Behind closed doors",
    "Later this evening",
    "Long journey ahead",
    "Chief executive officer",
    "Leader of pack",
    "Below sea level",
    "Down the street",
    "Under the bridge",
    "Study hard daily",
    "Learning never stops",
    "Science fair project",
    "Month of May",
    "Moon and stars",
    "What time now",
    "How many left",
    "Come here please",
    "Next week vacation",
    "Future looks bright",
    "Speak your mind",
    "Talk show host",
    "Story time begins",
    "Mountain peak high",
    "Hill climbing exercise",
    "High quality goods",
    "Tall building design",
    "Expensive taste preference",
    "Now or never",
    "Present moment awareness",
    "Write your name",
    "Name tag required",
    "Famous actor appears",
    "Gold medal winner",
    "Money talks loudly",
    "Metal detector beeps",
    "Man of honor",
    "Male lion roars",
    "Outside the box",
    "Foreign exchange student",
    "Before mentioned topic",
    "Ahead of schedule",
    "Previous experience helpful",
    "River flows downstream",
    "Stream of consciousness",
    "East coast trip",
    "West wind blows",
    "South of border",
    "North pole expedition",
    "Left turn ahead",
    "Right choice made",
    "Water runs deep",
    "Fire burns bright",
    "Tree grows tall",
    "Flower blooms spring",
    "Grass needs cutting",
    "Hand in hand",
    "Eye for detail",
    "Mouth watering food",
    "White snow falls",
    "Black coffee strong",
    "Red rose blooms",
    "Blue sky clear",
    "Heart beats strong",
    "Head held high",
    "Foot in door",
    "Fish swims upstream",
    "Bird flies south",
    "Dog barks loudly",
    "Cat sleeps peacefully",
    "School starts Monday",
    "Work never ends",
    "Car needs gas",
    "House for sale",
    "Door opens wide",
    "Window lets light",
    "Road leads home",
    "Friend helps always",
    "Mother knows best",
    "Father works hard",
    "Brother plays soccer",
    "Sister loves music",
    "Family dinner time",
    "Food tastes great",
    "Eat healthy meals",
    "Drink more water",
    "Sleep well tonight",
    "Think before acting",
    "Buy what needed",
    "Sell old items",
    "Make good choices",
    "Take your time",
    "Give helping hand",
    "Get some rest",
    "Put things away",
    "Keep trying hard",
    "Stop when tired",
    "Start over again",
    "End of story",
    "Begin new chapter",
    "Open your mind",
    "Close the gap",
    "Turn left here",
    "Move forward always",
    "Stand up straight",
    "Sit down please",
    "Walk the dog",
    "Run every morning",
    "Jump rope exercise",
    "Climb the mountain",
    "Fall leaves beautiful",
    "Rise and shine",
    "Push your limits",
    "Pull the rope",
    "Lift heavy weights",
    "Carry the load",
    "Hold on tight",
    "Let it go",
    "Send the message",
    "Receive good news",
    "Ask important questions",
    "Answer with honesty",
    "Learn something new",
    "Teach with patience",
    "Study every day",
    "Practice makes perfect",
    "Play music loudly",
    "Sing your song",
    "Dance all night",
    "Draw the picture",
    "Paint the wall",
    "Build something great",
    "Create new ideas",
    "Design better systems",
    "Plan ahead always",
    "Prepare for tomorrow",
    "Hope springs eternal",
    "Love conquers all",
    "Live life fully",
    "Die with dignity",
    "Born to run",
    "Grow old gracefully",
    "Change your ways",
    "Stay the course",
    "Leave no trace",
    "Return to sender",
    "Arrive on time",
    "Depart with grace",
    "Enter the contest",
    "Exit stage left",
    "Join the team",
    "Leave the past",
    "Meet new people",
    "Part ways peacefully",
    "Connect the dots",
    "Separate the wheat",
    "Unite for peace",
    "Divide by zero",
    "Add more value",
    "Subtract the noise",
    "Multiply your efforts",
    "Calculate the cost",
    "Measure twice carefully",
    "Count your blessings",
    "Number one priority",
    "First things first",
    "Last but not",
    "Next in line",
    "Final answer given",
    "Early bird special",
    "Late night snack",
    "Morning glory blooms",
    "Evening news reports",
    "Night owl hoots",
    "Today is Monday",
    "Yesterday was Sunday",
    "Tomorrow brings hope",
    "Past experience helps",
    "Present moment matters",
    "Future looks promising",
    "Always be kind",
    "Never give up",
    "Sometimes life hurts",
    "Often things change",
    "Usually works well",
    "Rarely seen bird",
    "Frequently asked questions",
    "Occasionally it rains",
    "Constantly in motion",
    "Immediately take action",
    "Suddenly the storm",
    "Quickly run home",
    "Slowly but surely",
    "Carefully consider options",
    "Clearly state purpose",
    "Completely understand now",
    "Perfectly timed event",
    "Exactly what needed",
    "Approximately ten minutes",
    "Nearly finished task",
    "Almost there now",
    "Quite interesting story",
    "Very good work",
    "Extremely hot weather",
    "Incredibly beautiful sunset",
    "Absolutely love music",
    "Definitely worth trying",
    "Probably the best",
    "Maybe tomorrow works",
    "Perhaps we should",
    "Possibly correct answer",
    "Certainly a challenge",
    "Obviously the winner",
    "Clearly the choice",
    "Simply the best",
    "Merely a suggestion",
    "Only one chance",
    "Just in time",
    "Even better now",
    "Still working hard",
    "Yet another day",
    "Already finished homework",
    "Indeed very wise",
    "Therefore we conclude",
    "However things change",
    "Although it rains",
    "Because I care",
    "Since you asked",
    "While we wait",
    "During the storm",
    "Through thick thin",
    "Across the street",
    "Around the corner",
    "Beyond the horizon",
    "Within walking distance",
    "Without any doubt",
    "Toward better future",
    "Against all odds",
    "Behind the scenes",
    "Beneath the surface",
    "Inside the house",
    "Outside the box",
    "Above the clouds",
    "Below the line",
    "Near the store",
    "Far from home",
    "Close to perfect",
    "Deep in thought",
    "Shallow water warning",
    "Thick winter coat",
    "Thin ice ahead",
    "Wide open spaces",
    "Narrow escape route",
    "Tall order indeed",
    "Short story long",
    "Heavy rain falls",
    "Light as feather",
    "Dark storm clouds",
    "Bright sunny day",
    "Hot summer weather",
    "Cold winter morning",
    "Warm spring breeze",
    "Cool autumn air",
    "Wet paint warning",
    "Dry desert sand",
    "Sweet victory taste",
    "Bitter cold wind",
    "Sour grapes attitude",
    "Salty ocean water",
    "Spicy food challenge",
    "Bland hospital food",
    "Rich chocolate cake",
    "Poor excuse given",
    "Old wise man",
    "New car smell",
    "Young at heart",
    "Ancient history lesson",
    "Modern art gallery",
    "Fresh morning air",
    "Stale bread crumbs",
    "Clean white shirt",
    "Dirty laundry pile",
    "Empty coffee cup",
    "Full moon rising",
    "Broken heart heals",
    "Fixed the problem",
    "Lost and found",
    "Found the treasure",
    "Missing puzzle piece",
    "Hidden secret revealed",
    "Visible from space",
    "Clear blue skies",
    "Cloudy with chance",
    "Sunny disposition shown",
    "Rainy day blues",
    "Snowy mountain peak",
    "Windy city nickname",
    "Calm before storm",
    "Rough seas ahead",
    "Smooth sailing now",
    "Bumpy ride ahead",
    "Straight and narrow",
    "Curved mountain road",
    "Round trip ticket",
    "Square peg hole",
    "Triangle has angles",
    "Circle of life",
    "Line in sand",
    "Point well taken",
    "Surface level understanding",
    "Edge of cliff",
    "Corner of room",
    "Side by side",
    "Top of mountain",
    "Bottom of barrel",
    "Front row seats",
    "Back to basics",
    "Middle ground found",
    "Interior design matters",
    "Exterior paint job",
    "Upper class citizen",
    "Lower your voice",
    "Inner peace found",
    "Outer space exploration",
    "Central heating works",
    "Local news report",
    "National treasure protected",
    "International flight delayed",
    "Global warming concern",
    "Universal truth revealed",
    "Personal space needed",
    "Private property sign",
    "Public speaking fear",
    "Official business only",
    "Unofficial test results",
    "Formal dinner invitation",
    "Informal chat session",
    "Regular maintenance schedule",
    "Special occasion dress",
    "Normal day routine",
    "Unusual circumstances arise",
    "Common sense prevails",
    "Rare bird sighting",
    "Typical Monday morning",
    "Unique opportunity arises",
    "General public invited",
    "Specific instructions given",
    "Exact change required",
    "Approximate arrival time",
    "Precise measurement taken",
    "Rough estimate given",
    "Accurate weather forecast",
    "Correct answer chosen",
    "Wrong turn taken",
    "Right decision made",
    "Left behind accidentally",
    "True story told",
    "False alarm sounded",
    "Real deal offered",
    "Fake jewelry store",
    "Honest mistake made",
    "Good news shared",
    "Bad weather coming",
    "Best effort given",
    "Worst case scenario",
    "Better late never",
    "Worse for wear",
    "Easy does it",
    "Hard work pays",
    "Difficult decision made",
    "Simple solution found",
    "Complex problem solved",
    "Complicated relationship status",
    "Straight forward approach",
    "Safe journey ahead",
    "Dangerous curve warning",
    "Secure password required",
    "Risky business venture",
    "Stable relationship foundation",
    "Unstable weather patterns",
    "Strong coffee needed",
    "Weak signal strength",
    "Powerful engine roars",
    "Gentle summer breeze",
    "Harsh winter conditions",
    "Soft pillow comfort",
    "Loud music playing",
    "Quiet library rules",
    "Silent night peace",
    "Noisy construction site",
    "Fast food restaurant",
    "Slow cooked meal",
    "Quick thinking saves",
    "Patient waiting pays",
    "Active lifestyle benefits",
    "Passive income stream",
    "Positive attitude helps",
    "Negative test results",
    "Happy birthday celebration",
    "Sad news received",
    "Angry words spoken",
    "Peaceful resolution reached",
    "Excited about trip",
    "Nervous about interview",
    "Confident in abilities",
    "Worried about future",
    "Relaxed vacation mode",
    "Stressed about deadline",
    "Calm under pressure",
    "Anxious waiting period",
    "Proud parent moment",
    "Ashamed of behavior",
    "Grateful for help",
    "Jealous of success",
    "Curious about outcome",
    "Bored with routine",
    "Interested in learning",
    "Tired after workout",
    "Refreshed after rest",
    "Hungry for knowledge",
    "Thirsty for adventure",
    "Sleepy after lunch",
    "Alert and ready",
    "Awake all night",
    "Busy schedule today",
    "Free time available",
    "Available for work",
    "Occupied bathroom sign",
    "Empty parking space",
    "Full service restaurant",
    "Half price sale",
    "Whole grain bread",
    "Part time job",
    "Complete the task",
    "Incomplete application form",
    "Perfect timing indeed",
    "Imperfect but beautiful",
    "Finished product ready",
    "Unfinished business remains",
    "Started from bottom",
    "Stopped at nothing",
    "Continued the journey",
    "Paused for reflection",
    "Resumed after break",
    "Ended on note",
    "Began with prayer",
    "Concluded the meeting",
    "Opened the door",
    "Closed for business",
    "Locked and loaded",
    "Unlocked the mystery",
    "Covered all bases",
    "Uncovered the truth",
    "Discovered new planet",
    "Explored uncharted territory",
    "Searched high low",
    "Found what needed",
    "Lost in translation",
    "Won the lottery",
    "Lost the game",
    "Gained valuable experience",
    "Earned respect daily",
    "Spent quality time",
    "Saved for future",
    "Wasted no time",
    "Invested wisely always",
    "Borrowed from library",
    "Lent helping hand",
    "Gave generous gift",
    "Received warm welcome",
    "Offered sincere apology",
    "Accepted the challenge",
    "Rejected the proposal",
    "Approved the budget",
    "Denied the request",
    "Granted the wish",
    "Refused the offer",
    "Agreed to terms",
    "Disagreed with decision",
    "Supported the cause",
    "Opposed the motion",
    "Favored the plan",
    "Objected to treatment",
    "Welcomed new member",
    "Dismissed the case",
    "Hired new employee",
    "Fired for cause",
    "Promoted to manager",
    "Demoted for performance",
    "Transferred to branch",
    "Relocated to city",
    "Moved to apartment",
    "Stayed at hotel",
    "Traveled by train",
    "Drove to work",
    "Walked to store",
    "Ran the marathon",
    "Flew to destination",
    "Sailed across ocean",
    "Swam in pool",
    "Climbed the tree",
    "Jumped over fence",
    "Crawled under table",
    "Rolled down hill",
    "Slid on ice",
    "Skipped the meeting",
    "Danced at wedding",
    "Sang in choir",
    "Played the piano",
    "Listened to music",
    "Watched the sunset",
    "Looked in mirror",
    "Saw the sunrise",
    "Heard the news",
    "Felt the breeze",
    "Touched the surface",
    "Smelled the flowers",
    "Tasted the soup",
    "Breathed fresh air",
    "Spoke the truth",
    "Whispered a secret",
    "Shouted for joy",
    "Cried tears joy",
    "Laughed at joke",
    "Smiled at stranger",
    "Frowned in disapproval",
    "Winked at friend",
    "Blinked in surprise",
    "Stared into space",
    "Glanced at clock",
    "Peeked around corner",
    "Gazed at stars",
    "Observed the behavior",
    "Noticed the difference",
    "Recognized the face",
    "Remembered the name",
    "Forgot the password",
    "Recalled the event",
    "Thought about future",
    "Considered all options",
    "Decided to stay",
    "Chose the winner",
    "Selected best candidate",
    "Picked fresh flowers",
    "Collected the mail",
    "Gathered the evidence",
    "Assembled the team",
    "Organized the files",
    "Arranged the meeting",
    "Planned the party",
    "Prepared the meal",
    "Cooked with love",
    "Baked fresh bread",
    "Served hot coffee",
    "Ate healthy food",
    "Drank cold water",
    "Swallowed the pill",
    "Chewed the food",
    "Digested the information",
    "Absorbed the lesson",
    "Understood the concept",
    "Comprehended the meaning",
    "Grasped the idea",
    "Realized the truth",
    "Recognized the pattern",
    "Acknowledged the mistake",
    "Admitted the error",
    "Confessed the secret",
    "Revealed the plan",
    "Disclosed the information",
    "Announced the winner",
    "Declared the result",
    "Proclaimed the news",
    "Stated the facts",
    "Mentioned the details",
    "Described the scene",
    "Explained the process",
    "Clarified the point",
    "Illustrated the concept",
    "Demonstrated the technique",
    "Showed the way",
    "Pointed the direction",
    "Indicated the location",
    "Marked the spot",
    "Signed the contract",
    "Stamped the document",
    "Sealed the envelope",
    "Opened the package",
    "Unpacked the box",
    "Wrapped the gift",
    "Tied the knot",
    "Untied the rope",
    "Fastened the belt",
    "Loosened the tie",
    "Tightened the screw",
    "Loosened the grip",
    "Held the baby",
    "Released the bird",
    "Caught the ball",
    "Threw the dice",
    "Rolled the paper",
    "Folded the clothes",
    "Unfolded the map",
    "Spread the news",
    "Scattered the seeds",
    "Collected the data",
    "Compiled the report",
    "Published the article",
    "Printed the document",
    "Copied the file",
    "Deleted the message",
    "Saved the work",
    "Backed up files",
    "Restored the system",
    "Updated the software",
    "Installed the program",
    "Uninstalled the app",
    "Downloaded the song",
    "Uploaded the photo",
    "Sent the email",
    "Received the package",
    "Forwarded the message",
    "Replied to question",
    "Answered the phone",
    "Called the doctor",
    "Dialed the number",
    "Hung up phone",
    "Connected the call",
    "Disconnected the line",
    "Transferred the call",
    "Recorded the message",
    "Played the recording",
    "Paused the video",
    "Stopped the music",
    "Rewound the tape",
    "Fast forwarded ahead",
    "Skipped the song",
    "Repeated the chorus",
    "Shuffled the playlist",
    "Turned up volume",
    "Turned down heat",
    "Switched on light",
    "Switched off power",
    "Plugged in device",
    "Unplugged the appliance",
    "Charged the battery",
    "Drained the pool",
    "Filled the tank",
    "Emptied the trash",
    "Cleaned the house",
    "Washed the dishes",
    "Dried the clothes",
    "Ironed the shirt",
    "Folded the towels",
    "Made the bed",
    "Vacuumed the carpet",
    "Swept the floor",
    "Mopped the kitchen",
    "Dusted the furniture",
    "Polished the silver",
    "Painted the wall",
    "Repaired the fence",
    "Fixed the leak",
    "Built the deck",
    "Demolished the wall",
    "Constructed the house",
    "Designed the layout",
    "Measured the room",
    "Cut the wood",
    "Sawed the board",
    "Hammered the nail",
    "Screwed the bolt",
    "Glued the pieces",
    "Taped the box",
    "Stapled the papers",
    "Clipped the coupon",
    "Pinned the note",
    "Stuck the label",
    "Peeled the fruit",
    "Sliced the bread",
    "Chopped the vegetables",
    "Diced the onion",
    "Minced the garlic",
    "Grated the cheese",
    "Squeezed the lemon",
    "Stirred the soup",
    "Mixed the batter",
    "Whipped the cream",
    "Beaten the eggs",
    "Kneaded the dough",
    "Rolled the pastry",
    "Baked the cookies",
    "Roasted the chicken",
    "Grilled the steak",
    "Fried the fish",
    "Boiled the water",
    "Steamed the rice",
    "Simmered the sauce",
    "Seasoned with salt",
    "Flavored with herbs",
    "Garnished the plate",
    "Served the dinner",
    "Cleared the table",
    "Loaded the dishwasher",
    "Unloaded the groceries",
    "Stored the leftovers",
    "Refrigerated the milk",
    "Froze the meat",
    "Thawed the chicken",
    "Heated the oven",
    "Cooled the pie",
    "Warmed the bread",
    "Chilled the wine",
    "Melted the butter",
    "Solidified the plan",
    "Liquefied the assets",
    "Crystallized the idea",
    "Vaporized the competition",
    "Condensed the report",
    "Expanded the business",
    "Contracted the muscle",
    "Stretched the budget",
    "Compressed the file",
    "Extended the deadline",
    "Shortened the meeting",
    "Lengthened the rope",
    "Widened the road",
    "Narrowed the search",
    "Deepened the understanding",
    "Shallowed the water",
    "Heightened the awareness",
    "Lowered the price",
    "Raised the flag",
    "Dropped the ball",
    "Lifted the weight",
    "Carried the load",
    "Dragged the bag",
    "Pulled the cart",
    "Pushed the button",
    "Pressed the key",
    "Squeezed the trigger",
    "Released the pressure",
    "Applied the brakes",
    "Accelerated the car",
    "Steered the wheel",
    "Parked the vehicle",
    "Started the engine",
    "Stopped the machine",
    "Operated the equipment",
    "Maintained the system",
    "Serviced the car",
    "Repaired the damage",
    "Replaced the part",
    "Upgraded the software",
    "Downgraded the plan",
    "Improved the process",
    "Worsened the situation",
    "Enhanced the experience",
    "Reduced the cost",
    "Increased the speed",
    "Decreased the volume",
    "Multiplied the efforts",
    "Divided the work",
    "Added the numbers",
    "Subtracted the amount",
    "Calculated the total",
    "Estimated the cost",
    "Approximated the distance",
    "Rounded the figure",
    "Squared the number",
    "Rooted the problem",
    "Powered the device",
    "Energized the team",
    "Motivated the staff",
    "Inspired the crowd",
    "Encouraged the effort",
    "Discouraged the behavior",
    "Supported the decision",
    "Opposed the plan",
    "Defended the position",
    "Attacked the problem",
    "Protected the children",
    "Endangered the species",
    "Preserved the culture",
    "Destroyed the evidence",
    "Created the artwork",
    "Invented the device",
    "Discovered the cure",
    "Developed the skill",
    "Evolved the strategy",
    "Adapted the approach",
    "Modified the design",
    "Altered the course",
    "Changed the world",
    "Transformed the industry",
    "Revolutionized the field",
    "Innovated the solution",
    "Pioneered the technology",
    "Advanced the cause",
    "Progressed through levels",
    "Regressed to basics",
    "Moved the furniture",
    "Shifted the paradigm",
    "Relocated the office",
    "Migrated the data",
    "Transferred the funds",
    "Transported the goods",
    "Delivered the package",
    "Shipped the order",
    "Mailed the letter",
    "Posted the update",
    "Published the book",
    "Broadcast the news",
    "Transmitted the signal",
    "Communicated the message",
    "Conveyed the emotion",
    "Expressed the feeling",
    "Articulated the vision",
    "Vocalized the concern",
    "Verbalized the thought",
    "Pronounced the word",
    "Enunciated each syllable",
    "Articulated the plan",
    "Mumbled the response",
    "Muttered under breath",
    "Whispered the secret",
    "Murmured soft words",
    "Hummed the tune",
    "Whistled the melody",
    "Sang the song",
    "Chanted the mantra",
    "Recited the poem",
    "Narrated the story",
    "Related the incident",
    "Reported the findings",
    "Documented the process",
    "Recorded the event",
    "Logged the hours",
    "Tracked the progress",
    "Monitored the situation",
    "Observed the behavior",
    "Watched the performance",
    "Viewed the presentation",
    "Examined the evidence",
    "Inspected the goods",
    "Investigated the case",
    "Researched the topic",
    "Studied the subject",
    "Analyzed the data",
    "Evaluated the options",
    "Assessed the risk",
    "Judged the contest",
    "Rated the movie",
    "Ranked the candidates",
    "Graded the papers",
    "Scored the game",
    "Counted the votes",
    "Tallied the results",
    "Summed the total",
    "Balanced the books",
    "Audited the accounts",
    "Reviewed the contract",
    "Revised the draft",
    "Edited the text",
    "Corrected the mistake",
    "Proofread the document",
    "Polished the presentation",
    "Refined the process",
    "Perfected the technique",
    "Mastered the skill",
    "Excelled at work",
    "Succeeded in life",
    "Failed the test",
    "Passed the exam",
    "Graduated from school",
    "Enrolled in course",
    "Attended the class",
    "Participated in discussion",
    "Contributed to society",
    "Donated to charity",
    "Volunteered for cause",
    "Helped the neighbor",
    "Assisted the customer",
    "Served the community",
    "Protected the environment",
    "Conserved the resources",
    "Recycled the materials",
    "Reduced the waste",
    "Reused the containers",
    "Repurposed the items",
    "Renewed the subscription",
    "Refreshed the page",
    "Restored the backup",
    "Retrieved the file",
    "Recovered the data",
    "Rescued the cat",
    "Saved the day",
    "Preserved the memory",
    "Maintained the tradition",
    "Continued the legacy",
    "Sustained the effort",
    "Endured the hardship",
    "Survived the storm",
    "Overcame the obstacle",
    "Conquered the fear",
    "Defeated the enemy",
    "Won the battle",
    "Lost the war",
    "Fought for freedom",
    "Battled the disease",
    "Struggled with decision",
    "Competed in race",
    "Participated in event",
    "Entered the contest",
    "Joined the club",
    "Belonged to group",
    "Became the leader",
    "Remained the friend",
    "Stayed the course",
    "Left the building",
    "Departed on time",
    "Arrived at destination",
    "Reached the goal",
    "Achieved the dream",
    "Attained the rank",
    "Obtained the license",
    "Acquired the skill",
    "Gained the knowledge",
    "Learned the lesson",
    "Taught the class",
    "Educated the public",
    "Informed the committee",
    "Notified the authorities",
    "Alerted the media",
    "Warned the people",
    "Cautioned against danger",
    "Advised the client",
    "Counseled the patient",
    "Guided the tour",
    "Directed the play",
    "Managed the project",
    "Supervised the work",
    "Oversaw the operation",
    "Administered the test",
    "Governed the state",
    "Ruled the kingdom",
    "Controlled the situation",
    "Regulated the industry",
    "Monitored the progress",
    "Tracked the shipment",
    "Followed the rules",
    "Obeyed the law",
    "Complied with regulations",
    "Adhered to standards",
    "Conformed to expectations",
    "Adapted to changes",
    "Adjusted the settings",
    "Modified the plan",
    "Altered the design",
    "Transformed the space",
    "Converted the currency",
    "Translated the text",
    "Interpreted the meaning",
    "Decoded the message",
    "Deciphered the code",
    "Solved the puzzle",
    "Resolved the conflict",
    "Settled the dispute",
    "Negotiated the deal",
    "Mediated the discussion",
    "Facilitated the meeting",
    "Coordinated the effort",
    "Organized the event",
    "Planned the trip",
    "Scheduled the appointment",
    "Arranged the flowers",
    "Decorated the room",
    "Furnished the apartment",
    "Equipped the team",
    "Supplied the materials",
    "Provided the service",
    "Offered the deal",
    "Presented the gift",
    "Delivered the speech",
    "Performed the surgery",
    "Conducted the interview",
    "Hosted the party",
    "Entertained the guests",
    "Amused the children",
    "Delighted the audience",
    "Pleased the customer",
    "Satisfied the requirement",
    "Fulfilled the promise",
    "Completed the task",
    "Finished the project",
    "Ended the relationship",
    "Concluded the meeting",
    "Terminated the contract",
    "Canceled the order",
    "Postponed the event",
    "Delayed the flight",
    "Rescheduled the meeting",
    "Advanced the timeline",
    "Accelerated the process",
    "Expedited the delivery",
    "Rushed the job",
    "Hurried to finish",
    "Speeded up production",
    "Slowed down traffic",
    "Stopped the bleeding",
    "Halted the process",
    "Paused for breath",
    "Resumed the work",
    "Continued the story",
    "Persisted in effort",
    "Persevered through hardship",
    "Endured the pain",
    "Tolerated the noise",
    "Accepted the challenge",
    "Embraced the change",
    "Welcomed the opportunity",
    "Greeted the visitor",
    "Acknowledged the gift",
    "Appreciated the effort",
    "Valued the friendship",
    "Treasured the memory",
    "Cherished the moment",
    "Loved the family",
    "Adored the puppy",
    "Worshipped the hero",
    "Admired the courage",
    "Respected the elder",
    "Honored the veteran",
    "Celebrated the victory",
    "Commemorated the event",
    "Remembered the fallen",
    "Mourned the loss",
    "Grieved the death",
    "Wept for joy",
    "Cried in pain",
    "Sobbed with relief",
    "Laughed at comedy",
    "Chuckled at joke",
    "Giggled with friend",
    "Smiled with happiness",
    "Grinned from ear",
    "Beamed with pride",
    "Glowed with health",
    "Radiated positive energy",
    "Emanated warm feelings",
    "Exuded confidence daily",
    "Projected strong image",
    "Reflected inner peace",
    "Mirrored the behavior",
    "Echoed the sentiment",
    "Resonated with audience",
    "Vibrated with excitement",
    "Pulsed with life",
    "Throbbed with pain",
    "Ached with longing",
    "Yearned for home",
    "Longed for peace",
    "Craved for attention",
    "Desired true love",
    "Wanted simple life",
    "Needed more time",
    "Required immediate attention",
    "Demanded fair treatment",
    "Requested more information",
    "Asked polite question",
    "Inquired about price",
    "Questioned the motive",
    "Doubted the story",
    "Suspected foul play",
    "Believed in magic",
    "Trusted the process",
    "Relied on friends",
    "Depended on family",
    "Counted on support",
    "Expected good news",
    "Anticipated great things",
    "Predicted the outcome",
    "Forecasted the weather",
    "Projected the earnings",
    "Estimated the cost",
    "Calculated the risk",
    "Computed the average",
    "Determined the winner",
    "Decided the fate",
    "Resolved the issue",
    "Concluded the investigation",
    "Inferred the meaning",
    "Deduced the answer",
    "Reasoned through problem",
    "Logically approached situation",
    "Rationally considered options",
    "Thoughtfully made decision",
    "Carefully planned ahead",
    "Meticulously prepared presentation",
    "Thoroughly researched topic",
    "Comprehensively covered subject",
    "Extensively studied material",
    "Intensively trained daily",
    "Rigorously tested product",
    "Strictly followed protocol",
    "Precisely measured ingredients",
    "Accurately recorded data",
    "Correctly answered question",
    "Properly handled situation",
    "Appropriately responded to crisis",
    "Suitably dressed occasion",
    "Adequately prepared meal",
    "Sufficiently covered topic",
    "Barely passed test",
    "Hardly recognized face",
    "Scarcely had time",
    "Rarely seen phenomenon",
    "Seldom used feature",
    "Occasionally visited place",
    "Sometimes wondered why",
    "Often thought about",
    "Frequently asked question",
    "Regularly exercised daily",
    "Consistently delivered results",
    "Constantly improved skills",
    "Continuously learned new",
    "Perpetually sought knowledge",
    "Eternally grateful for",
    "Forever remembered moment",
    "Always believed in",
    "Never gave up",
    "Temporarily closed business",
    "Permanently moved away",
    "Briefly visited town",
    "Quickly finished work",
    "Slowly walked home",
    "Gradually understood concept",
    "Suddenly realized truth",
    "Immediately took action",
    "Eventually reached destination",
    "Finally found answer",
    "Initially resisted change",
    "Originally planned trip",
    "Previously worked there",
    "Formerly lived here",
    "Currently studying abroad",
    "Presently working hard",
    "Recently moved house",
    "Lately feeling tired",
    "Soon will graduate",
    "Shortly after noon",
    "Later that evening",
    "Earlier this morning",
    "Yesterday was Monday",
    "Today is Tuesday",
    "Tomorrow will bring",
    "Last week visited",
    "This week working",
    "Next week vacation",
    "Every day exercise",
    "Each person unique",
    "All people equal",
    "Some prefer coffee",
    "Many enjoy music",
    "Few understand art",
    "Several options available",
    "Various methods work",
    "Different approaches needed",
    "Similar results expected",
    "Identical twins born",
    "Equal opportunity employer",
    "Fair trade coffee",
    "Just price paid",
    "Right decision made",
    "Correct answer given",
    "Proper procedure followed",
    "Appropriate response provided",
    "Suitable candidate selected",
    "Fitting tribute paid",
    "Perfect timing achieved",
    "Ideal solution found",
    "Optimal result obtained",
    "Maximum effort given",
    "Minimum wage earned",
    "Average score achieved",
    "Standard procedure followed",
    "Normal day routine",
    "Regular maintenance performed",
    "Ordinary people extraordinary",
    "Common sense prevailed",
    "Typical response expected",
    "Usual suspects gathered",
    "Customary greeting exchanged",
    "Traditional values upheld",
    "Conventional wisdom questioned",
    "Classical music played",
    "Modern art appreciated",
    "Contemporary issues discussed",
    "Current events reported",
    "Recent developments noted",
    "Latest news shared",
    "Updated information provided",
    "Revised plan presented",
    "Improved version released",
    "Enhanced features added",
    "Advanced technology used",
    "Sophisticated system installed",
    "Complex problem solved",
    "Complicated situation resolved",
    "Difficult task completed",
    "Challenging project finished",
    "Hard work rewarded",
    "Tough decision made",
    "Rough draft written",
    "Smooth operation maintained",
    "Easy solution found",
    "Simple answer given",
    "Basic needs met",
    "Elementary school attended",
    "Primary concern addressed",
    "Main goal achieved",
    "Principal reason given",
    "Chief executive appointed",
    "Head of department",
    "Leader of group",
    "Boss of company",
    "Manager of store",
    "Supervisor of staff",
    "Director of film",
    "Producer of show",
    "Creator of art",
    "Inventor of device",
    "Founder of organization",
    "Pioneer of movement",
    "Originator of idea",
    "Author of book",
    "Writer of article",
    "Composer of music",
    "Artist of painting",
    "Sculptor of statue",
    "Designer of building",
    "Architect of plan",
    "Engineer of bridge",
    "Builder of house",
    "Constructor of road",
    "Manufacturer of product",
    "Producer of goods",
    "Supplier of materials",
    "Distributor of items",
    "Retailer of clothes",
    "Vendor of food",
    "Merchant of goods",
    "Trader of stocks",
    "Investor in company",
    "Buyer of property",
    "Seller of car",
    "Owner of business",
    "Proprietor of shop",
    "Landlord of building",
    "Tenant of apartment",
    "Renter of house",
    "Occupant of room",
    "Resident of city",
    "Inhabitant of planet",
    "Citizen of country",
    "Native of land",
    "Local of area",
    "Neighbor next door",
    "Friend for life",
    "Companion on journey",
    "Partner in business",
    "Colleague at work",
    "Teammate on field",
    "Member of club",
    "Participant in event",
    "Contestant in game",
    "Competitor in race",
    "Rival in sport",
    "Opponent in match",
    "Enemy in war",
    "Adversary in court",
    "Challenger to champion",
    "Contender for title",
    "Candidate for office",
    "Nominee for award",
    "Winner of prize",
    "Champion of cause",
    "Victor in battle",
    "Conqueror of land",
    "Hero of story",
    "Star of show",
    "Celebrity on stage",
    "Famous person known",
    "Well known figure",
    "Popular choice made",
    "Favorite song played",
    "Beloved family member",
    "Dear friend remembered",
    "Precious memory kept",
    "Valuable lesson learned",
    "Important message delivered",
    "Significant event occurred",
    "Major breakthrough achieved",
    "Minor adjustment made",
    "Slight change noticed",
    "Small step taken",
    "Tiny detail matters",
    "Huge success celebrated",
    "Massive project completed",
    "Enormous task finished",
    "Giant leap forward",
    "Colossal effort made",
    "Tremendous progress achieved",
    "Outstanding performance given",
    "Excellent work done",
    "Great job completed",
    "Good news received",
    "Fine day enjoyed",
    "Nice weather appreciated",
    "Pleasant surprise received",
    "Wonderful time had",
    "Marvelous experience shared",
    "Amazing discovery made",
    "Incredible story told",
    "Fantastic opportunity given",
    "Terrific idea suggested",
    "Brilliant solution found",
    "Genius plan created",
    "Clever trick worked",
    "Smart choice made",
    "Wise decision taken",
    "Intelligent approach used",
    "Thoughtful gift given",
    "Considerate gesture made",
    "Kind words spoken",
    "Gentle touch felt",
    "Soft voice heard",
    "Quiet moment shared",
    "Silent prayer offered",
    "Peaceful resolution reached",
    "Calm before storm",
    "Serene lake reflected",
    "Tranquil evening enjoyed",
    "Relaxing vacation taken",
    "Restful sleep achieved",
    "Refreshing drink served",
    "Cool breeze felt",
    "Fresh air breathed",
    "Clean water provided",
    "Pure heart shown",
    "Clear mind focused",
    "Sharp wit displayed",
    "Quick thinking saved",
    "Fast action taken",
    "Rapid response given",
    "Immediate help provided",
    "Instant results achieved",
    "Direct approach used",
    "Straight path taken",
    "Honest answer given",
    "Truthful statement made",
    "Sincere apology offered",
    "Genuine concern shown",
    "Real friendship formed",
    "Authentic experience had",
    "Original idea presented",
    "Unique opportunity seized",
    "Special moment shared",
    "Rare occurrence witnessed",
    "Unusual event happened",
    "Strange behavior noticed",
    "Odd coincidence occurred",
    "Weird feeling experienced",
    "Mysterious message received",
    "Secret plan revealed",
    "Hidden treasure found",
    "Lost item recovered",
    "Missing piece discovered",
    "Forgotten memory recalled",
    "Remembered promise kept",
    "Unforgotten sacrifice honored",
    "Memorable experience shared",
    "Remarkable achievement recognized",
    "Notable progress made",
    "Noteworthy contribution given",
    "Impressive performance delivered",
    "Striking resemblance noticed",
    "Stunning revelation made",
    "Shocking news reported",
    "Surprising turn taken",
    "Unexpected result achieved",
    "Unpredictable outcome occurred",
    "Uncertain future faced",
    "Unclear instructions given",
    "Unfinished business addressed",
    "Incomplete task resumed",
    "Unresolved issue tackled",
    "Unsolved mystery investigated",
    "Unknown territory explored",
    "Unfamiliar place visited",
    "Uncharted waters navigated",
    "Unexplored possibilities considered",
    "Untested theory proposed",
    "Unproven method tried",
    "Unsuccessful attempt made",
    "Unfortunate event occurred",
    "Unlucky break happened",
    "Unhappy ending reached",
    "Unsatisfied customer served",
    "Disappointed expectation managed",
    "Frustrated attempt continued",
    "Annoyed response given",
    "Irritated reaction shown",
    "Angry words exchanged",
    "Furious argument started",
    "Enraged behavior displayed",
    "Calm discussion held",
    "Peaceful negotiation conducted",
    "Harmonious relationship maintained",
    "Balanced approach taken",
    "Stable foundation built",
    "Solid ground found",
    "Firm decision made",
    "Strong foundation laid",
    "Weak argument presented",
    "Fragile situation handled",
    "Delicate matter addressed",
    "Sensitive issue discussed",
    "Vulnerable position exposed",
    "Protected space created",
    "Safe environment maintained",
    "Secure system installed",
    "Dangerous situation avoided",
    "Risky behavior discouraged",
    "Hazardous material handled",
    "Toxic relationship ended",
    "Poisonous atmosphere cleared",
    "Healthy lifestyle adopted",
    "Fit body maintained",
    "Strong muscles built",
    "Flexible schedule arranged",
    "Rigid structure imposed",
    "Fixed problem solved",
    "Broken item repaired",
    "Damaged goods replaced",
    "Ruined plan abandoned",
    "Destroyed building demolished",
    "Rebuilt from scratch",
    "Restored to glory",
    "Renewed with energy",
    "Refreshed with sleep",
    "Revived with coffee",
    "Energized with exercise",
    "Motivated by success",
    "Inspired by beauty",
    "Encouraged by friend",
    "Supported by family",
    "Helped by stranger",
    "Assisted by professional",
    "Guided by wisdom",
    "Led by example",
    "Followed by crowd",
    "Pursued by enemy",
    "Chased by dog",
    "Hunted by predator",
    "Tracked by GPS",
    "Monitored by camera",
    "Watched by guard",
    "Observed by scientist",
    "Studied by researcher",
    "Examined by doctor",
    "Inspected by officer",
    "Investigated by detective",
    "Questioned by police",
    "Interviewed by reporter",
    "Surveyed by team",
    "Polled by organization",
    "Tested by expert",
    "Evaluated by committee",
    "Assessed by professional",
    "Judged by jury",
    "Rated by critic",
    "Reviewed by peer",
    "Critiqued by teacher",
    "Graded by professor",
    "Scored by referee",
    "Measured by standard",
    "Weighed by scale",
    "Counted by machine",
    "Calculated by computer",
    "Computed by algorithm",
    "Processed by system",
    "Handled by robot",
    "Managed by software",
    "Controlled by program",
    "Operated by user",
    "Driven by passion",
    "Powered by electricity",
    "Fueled by ambition",
    "Charged with energy",
    "Loaded with potential",
    "Filled with hope",
    "Packed with information",
    "Stuffed with knowledge",
    "Crammed with facts",
    "Overflowing with joy",
    "Bursting with pride",
    "Brimming with confidence",
    "Radiating with happiness",
    "Glowing with health",
    "Shining with success",
    "Sparkling with wit",
    "Twinkling with mischief",
    "Flickering with doubt",
    "Dimming with age",
    "Fading with time",
    "Disappearing into darkness",
    "Vanishing without trace",
    "Emerging from shadow",
    "Appearing suddenly now",
    "Materializing before eyes",
    "Manifesting into reality",
    "Becoming more obvious",
    "Growing in strength",
    "Developing new skills",
    "Evolving with time",
    "Progressing through stages",
    "Advancing toward goal",
    "Moving forward always",
    "Proceeding with caution",
    "Continuing the journey",
    "Persisting despite obstacles",
    "Enduring through hardship",
    "Surviving the storm",
    "Thriving in environment",
    "Flourishing under care",
    "Blooming in spring",
    "Blossoming into beauty",
    "Flowering with color",
    "Ripening in sun",
    "Maturing with experience",
    "Aging with grace",
    "Weathering the changes",
    "Withstanding the pressure",
    "Resisting the temptation",
    "Fighting the good",
    "Struggling with problem",
    "Wrestling with decision",
    "Battling the elements",
    "Competing for position",
    "Contending with rival",
    "Challenging the status",
    "Confronting the truth",
    "Facing the music",
    "Meeting the deadline",
    "Approaching the finish",
    "Nearing the end",
    "Reaching the summit",
    "Arriving at conclusion",
    "Attaining the goal",
    "Achieving the dream",
    "Accomplishing the mission",
    "Fulfilling the promise",
    "Completing the circle",
    "Finishing the race",
    "Ending on note",
    "Concluding with success",
    "Terminating with grace",
    "Closing the chapter",
    "Wrapping up project",
    "Bringing to close",
    "Coming to end",
    "Drawing to conclusion",
    "Winding down slowly",
    "Tapering off gradually",
    "Phasing out completely",
    "Shutting down system",
    "Turning off machine",
    "Switching off light",
    "Powering down computer",
    "Logging off account",
    "Signing out now",
    "Checking out hotel",
    "Leaving the building",
    "Exiting the program",
    "Departing on schedule",
    "Going home now",
    "Returning to base",
    "Coming back soon",
    "Arriving home safely",
    "Reaching final destination",

    // Additional targeted sentences for missing character coverage
    "Ten thousand people gathered",
    "Ten thousand dollars spent",
    "Hundred years ago",
    "Hundred percent sure",
    "Thousand miles journey",
    "Thousand thanks given",
    "Electricity powers homes",
    "Electric cars popular",
    "Rice field workers",
    "Farm animals grazing",
    "Capital city busy",
    "Tokyo very crowded",
    "Silver medal won",
    "Silver jewelry shines",
    "Meat for dinner",
    "Flesh and blood",
    "Older brother helps",
    "Younger brother plays",
    "Hall meeting tonight",
    "Temple visit peaceful",
    "Stop the car",
    "Urgent message received",
    "Sudden change happened",
    "Copy this document",
    "Photograph looks nice",
    "Illness requires rest",
    "Sick day needed",
    "Color the picture",
    "Foot hurts today",
    "Leg muscles sore",
    "Sufficient funds available",
    "Parent teacher meeting",
    "Relative came visiting",
    "Intimate conversation shared",
    "Pass through tunnel",
    "Commute to work",
    "Communicate clearly always",
    "Thing of beauty",
    "Object lesson learned",
    "Hear the music",
    "Listen carefully please",
    "Yen currency strong",
    "Vehicle needs repair",
    "Wheel turns slowly",
    "Half the distance",
    "Soil grows plants",
    "Proof of purchase",
    "Oneself must decide",
    "Someone called earlier",
    "Fact remains true",
    "Association meeting scheduled",
    "Target practice today",
    "Objective clearly stated",
    "Eye sees clearly",
    "Location not found",
    "Substitute teacher came",
    "Era of change",
    "Private property sign",
    "Rise early morning",
    "Body needs rest",
    "Shrine visit planned",
    "Logic dictates action",
    "Principle stands firm",
    "Depart on time",
    "Emit bright light",
    "Degree of difficulty",
    "Extent of damage",
    "Force of nature",
    "Intention was good",
    "Master the skill",
    "Lord of manor",
    "Sentence structure matters",
    "Dealer sells cars",
    "Possess great wisdom",
    "Opening ceremony begins",
    "Entrance exam difficult",
    "Plain simple truth",
    "Wild animals roam",
    "Unfold the map",
    "Religion brings peace",
    "Flavor tastes good",
    "Boundary line drawn",
    "None shall pass",
    "Few people came",
    "Small amount left",
    "Slice the bread",
    "Pile of books",
    "Collect the data",
    "Drawing looks nice",
    "Stroke of genius",
    "Death comes naturally",
    "Die with honor",
    "Cheap price offered",
    "Title of book",
    "Theme of story",
    "Sound of music",
    "Former president spoke",
    "Beginning of end",
    "Particular interest shown",
    "Style of writing",
    "Manner of speaking",
    "Exist in harmony",
    "Occur naturally always",
    "Carry the load",
    "Luck runs out",
    "Fortune favors bold",
    "Fee required upfront",
    "Evil cannot win",
    "Broad spectrum coverage",
    "City block party",
    "Reside in peace",
    "Institution of learning",
    "See off guests",
    "Tribe gathers together",
    "Clan celebrates victory",
    "Wild nature preserve",
    "A lot of work",
    "Arrive on schedule",
    "Attach the file",
    "Separate the items",
    "Arrive at destination",
    "Older sister helps",
    "Younger sister plays",
    "Day of week",
    "Cow gives milk",
    "Bull runs fast",
    "Lend me money",
    "Borrow some time",
    "Station platform busy",
    "Opposite direction taken",
    "Versus the opponent",
    "Anti virus software",
    "Connection established successfully",
    "Barrier blocks path",
    "Gateway to success",
    "Politics affects everyone",
    "Government makes decisions",
    "Sutra teaches wisdom",
    "Longitude measures distance",
    "Take along friends",
    "Lead the way",
    "Join the team",
    "Meadow flowers bloom",
    "Original idea shared",
    "Primitive tools used",
    "Reign of peace",
    "Calm down please",
    "Crowded street corner",
    "Mixture of colors",
    "In general terms",
    "Lively music plays",
    "Resuscitation successful today",
    "Being helped greatly",
    "Association meets monthly",
    "Braid the hair",
    "Plait the rope",
    "Finger points direction",
    "Point to location",
    "Indicate the answer",

    // Massive sentence addition for 100% coverage - first batch
    "Laugh out loud",
    "Stone wall built",
    "Stone foundation solid",
    "Transmit the message",
    "Go along path",
    "Walk along river",
    "Fond of music",
    "Pleasing to eye",
    "Like something new",
    "Years old today",
    "Counter for years",
    "Release the bird",
    "Set free animals",
    "Remain here please",
    "Leftover food saved",
    "Judge the case",
    "Seal the envelope",
    "Honorable mention given",
    "Control the situation",
    "Refuse the offer",
    "Cut off ties",
    "Announce the winner",
    "Accuse the suspect",
    "Thrust the sword",
    "Contain the excitement",
    "Appearance matters most",
    "Erase the mistake",
    "Disappear without trace",
    "Chase the dream",
    "Pursue your goals",
    "Admonish the child",
    "Bureau of statistics",
    "Throw the ball",
    "Invest wisely always",
    "Obtain good results",
    "Reap what sown",
    "Grade the papers",
    "Steps to success",
    "Transit through city",
    "Ferry across river",
    "Bestow great honor",
    "Participate in event",
    "Pull out weeds",
    "Extract the juice",
    "Cut off communication",
    "Discontinue the service",
    "Alcohol is harmful",
    "Sake tastes good",
    "Guess the answer",
    "Judge by appearance",
    "Marriage is beautiful",
    "Wife loves husband",
    "Cross over bridge",
    "Exceed expectations always",
    "Not yet ready",
    "Retreat from battle",
    "Withdraw from account",
    "Daughter grows up",
    "Girl plays outside",
    "Crime rate rising",
    "Violate the rules",
    "Inn provides shelter",
    "Lodge in mountains",
    "Fall down stairs",
    "Overthrow the government",
    "Surplus food donated",
    "Remainder after division",
    "Belly feels full",
    "Stomach hurts badly",
    "Permit the action",
    "Allow more time",
    "Accumulate great wealth",
    "Pile up papers",
    "Ear hears sound",
    "Crime doesn't pay",
    "Sin brings guilt",
    "Scatter the seeds",
    "Disperse the crowd",
    "Hang the picture",
    "Spend more money",
    "Anger clouds judgment",
    "Get angry quickly",
    "Detain the suspect",
    "Fasten your seatbelt",
    "Manners are important",
    "Courtesy goes far",
    "Pay the bill",
    "Sweep away dirt",
    "Defeat is temporary",
    "Failure teaches lessons",
    "Catch the fish",
    "Capture the moment",
    "Forget the past",
    "Clear weather today",
    "Harbor safe place",
    "Port welcomes ships",
    "Exclude from group",
    "Remove the stain",
    "Suck through straw",
    "Inhale deeply now",
    "Bundle of joy",
    "Bunch of flowers",
    "Window opens wide",
    "Ancestor lived here",
    "Founder of company",
    "Long ago remembered",
    "Former president spoke",
    "Convenience store open",
    "Mail arrives daily",
    "Blow out candles",
    "Anti war movement",
    "Distribute equal shares", 
    "Arrange the meeting",
    "Thrust forward boldly",
    "Metropolis is crowded",
    "Capital punishment debated",
    "Condition worsens daily",
    "Letter sent yesterday",
    "Older brother works",
    "Younger brother studies",
    "Older sister cooks", 
    "Younger sister sings",
    "Day of week",
    "Lend money carefully",
    "Opinion varies widely",
    "Theory proves correct",
    "Explanation needed now",
    "Leaf turns yellow",
    "Laugh heartily together",
    "Adhere to schedule",
    "Attach great importance",
    "Refer to handbook",
    "Kill time waiting",
    "Murder mystery solved",
    "Dispute settled peacefully",
    "Compete for trophy",
    "Bring up topic",
    "Nurture young minds",
    "Acknowledge your mistake",
    "Recognize good work",
    "Lose your temper",
    "Miss the point",
    "King of jungle",
    "Monarch butterfly flies",
    "Tenderness shown daily",
    "Superior performance noted",
    "Bureau handles paperwork",
    "Throw second pitch",
    "Invest in future",
    "Harm none today",
    "Injury requires treatment",
    "Suffering ends eventually",
    "Bitter taste lingers",
    "Example demonstrates clearly",
    "Instance proves rule",
    "Lose hope never",
    "Defeat teaches humility",
    "Bear responsibility always",
    "Anti war movement",
    "Anti virus software",
    "Admonish the lazy student",
    "Parents admonish their children",
    "Marriage is beautiful ceremony",
    "Happy marriage brings joy",
    "Speed limit zone ahead",
    "Limit your sugar intake",
    "Restrict access to building",
    "Rules restrict our freedom",
    "My wife cooks dinner",
    "Wife enjoys reading books",
    "Not yet finished work",
    "Not yet ready today",
    "Un lock the door",
    "Un wrap the gift",
    "Hard labor builds character",
    "Labor unions negotiate wages",
    "Car trouble on highway",
    "Trouble follows him everywhere",
    "Escape from the prison",
    "Quick escape through window",
    "Run away from danger",
    "Children run away giggling",
    "Twins resemble each other",
    "You resemble your father",
    "Dogs are similar creatures",
    "Similar ideas were shared",
    "Dark clouds gather overhead",
    "Dark room needs light",
    "Gloomy weather today unfortunately",
    "Gloomy thoughts cloud mind",
    "Monthly salary was raised",
    "Good salary attracts workers",
    "Supply fresh water daily",
    "Limited supply of food",
    "Never forget your dreams",
    "Forget about past mistakes",
    "Clear weather for picnic",
    "Weather forecast shows clear",
    "Brush your hair daily",
    "Long hair needs care",
    "Smoke fills the room",
    "Campfire smoke rises up",
    "Teacher guides faithful disciple",
    "Disciple follows master closely",
    "Walk on foot today",
    "Journey on foot begun",
    "Plants lack sufficient water",
    "Lack of sleep hurts",
    "Notice absence of birds",
    "His absence was noted",
    "Tourists get lost easily",
    "Get lost in woods",
    "Ship went astray tonight",
    "Sheep wandered far astray",
    "Wash your hands thoroughly",
    "Wash dishes after dinner",
    "Brush tooth before bed",
    "Lost tooth under pillow",
    "Thieves steal valuable jewelry",
    "Never steal from others",
    "Get used to changes",
    "Get used to routine",
    "Invite friends for dinner",
    "Invite neighbors to party",
    "Wave hands to beckon",
    "Beckon the taxi driver",
    "Feel shame for mistakes",
    "Shame prevents honest communication",
    "Poor family needs help",
    "Poor decision caused problems",
    "Poverty affects many families",
    "Escape from grinding poverty",
    "Committee will approve proposal",
    "Manager must approve expenses",
    "Praise good work done",
    "Teachers praise student effort",
    "Accidental meeting at store",
    "Accidental spill on shirt",
    "Even numbers divide evenly",
    "Even children understand rules",
    "Fish swim in ocean",
    "Learn to swim today",
    "New shoes feel comfortable",
    "Remove wet muddy shoes",
    "Tropical island has beaches",
    "Island surrounded by water",
    "Small village by river",
    "Village people are friendly",
    "Ancient castle on hill",
    "Castle walls protect inhabitants",
    "Establish new business rules",
    "Establish clear communication lines",
    "Set up camping tent",
    "Set up meeting time",
    "Manage daily work schedule",
    "Manage finances very carefully",
    "Operate heavy machinery safely",
    "Operate computer with care",
    "Prefecture government announces changes",
    "Prefecture includes many cities",
    "Government office closes early",
    "Visit government office tomorrow",
    "Mediate dispute between neighbors",
    "Judge will mediate conflict",
    "Fresh shellfish at market",
    "Collect shellfish at beach",
    "Tree root grows deep",
    "Root of problem identified",
    "Basis for strong friendship",
    "Scientific basis for theory",
    "Ancient temple attracts visitors",
    "Temple bells ring loudly",
    "Police investigate the crime",
    "Scientists investigate new findings",
    "Deep valley between mountains",
    "River flows through valley",
    "Blood flows through veins",
    "Donate blood to help",
    "Calculate total monthly expenses",
    "Calculate distance to destination",
    "Large elephant at zoo",
    "Elephant remembers everything clearly",
    "Strange phenomenon in sky",
    "Natural phenomenon occurs regularly",
    "Sweet fragrance fills air",
    "Rose fragrance is lovely",
    "Burning incense smells good",
    "Light incense for meditation",
    "Long time no see",
    "Long time since vacation",
    "City ward meeting tonight",
    "Hospital ward needs volunteers",
    "Shopping district very busy",
    "School district has funding",
    "Strong iron gate protects",
    "Iron rusts in rain",
    "Stainless steel is durable",
    "Steel beams support building",
    "Edit document before printing",
    "Edit video for presentation",
    "Knit warm winter sweater",
    "Grandmother likes to knit",
    "Compare prices before buying",
    "Compare different travel options",
    "Equip soldiers with armor",
    "Equip kitchen with appliances",
    "Dress appropriately for interview",
    "Blue dress looks beautiful",
    "Pay income tax annually",
    "High tax on imports",
    "Teams compete for trophy",
    "Athletes compete in Olympics",
    "Mountains surround the valley",
    "Fence will surround garden",
    "Hospital in close vicinity",
    "Shops in immediate vicinity",
    "Small area needs cleaning",
    "Protected area for wildlife",
    "Prevent accidents from happening",
    "Medicine helps prevent illness",
    "Soldiers defend their country",
    "Defend your position strongly",
    "Low bridge ahead warning",
    "Keep voice volume low",
    "Pain in chest area",
    "Chest contains valuable treasures",
    "Medical treatment saves lives",
    "Treatment worked very well",
    "Genuine leather jacket expensive",
    "Prison reform is necessary",
    "Medicine has positive effect",
    "Effect lasts several hours",
    "Mental disorder requires treatment",
    "Traffic disorder causes delays",
    "Peasant revolt against king",
    "Teenagers revolt against rules",
    "Soft cloth feels comfortable",
    "Disease can spread quickly",
    "Buddha statue in temple",
    "France is beautiful country",
    "Old warehouse stores goods",
    "Government treasury holds gold",
    "Doctor has medical specialty",
    "Exclusive club for members",
    "Bamboo grows very quickly",
    "New edition of book",
    "Printing plate needs replacement",
    "Universe contains countless stars",
    "Roof leaks during storms",
    "Vitamin supplement improves health",
    "Insurance will compensate loss",
    "Hundred million people live",
    "Shoulder injury prevents lifting",
    "Drama class starts Monday",
    "Intense heat wave continues",
    "Thorn can stab finger",
    "Rose thorn is sharp",
    "South Korea exports technology",
    "Winter clothing keeps warm",
    "Designer garment costs more",
    "Dog bone is buried",
    "Rock layer contains fossils",
    "Geological stratum shows history",
    "Human brain processes information",
    "Fireworks explode in sky",
    "Cooking oil prevents sticking",
    "Fans shout team name",
    "Children shout with joy",
    "Introduce yourself to others",
    "Army will occupy territory",
    "Fortune telling predicts future",
    "Animal skin protects body",
    "Grandchild visits grandmother weekly",
    "Measure length of rope",
    "Tower will incline slightly",
    "Patient is afflicted badly",
    "Beautiful bay attracts tourists",
    "Europe has many countries",
    "Heavy luggage slows travel",
    "Wish longevity to grandparents",
    "Fresh vegetable tastes better",
    "Leafy greens provide nutrition",
    "Liquid medicine tastes bitter",
    "Snake venom is poison",
    "Vice president leads meeting",
    "Teaching assistant grades papers",
    "Young boy plays soccer",
    "Buddhist priest chants prayers",
    "Sweat drips during exercise",
    "Road width allows traffic",
    "Mountain range extends far",
    "Tiny insect crawls slowly",
    "Beetle bug is harmless",
    "Darkness surrounds the house",
    "Fabric texture feels smooth",
    "Mountain lake reflects sky",
    "Injured knee needs rest",
    "House eaves need cleaning",
    "Family surname is important",
    "Famous family name recognized",
    "Valuable mineral found underground",
    "Quiet suburb attracts families",
    "Copper wire conducts electricity",
    "Religious symbol represents faith",
    "Livestock graze in fields",
    "Sky becomes very cloudy",
    "Light becomes quite dim",
    "Traditional family name honored",
    "True gentleman helps others",
    "Ancient samurai served lords",
    "Purple wisteria blooms beautifully",
    "Quiet bay reflects moonlight",
    "River inlet provides harbor",
    "Look at the stars",
    "Regard with high respect",
    "Emperor rules the nation",
    "Imperial palace guards protect",
    "Military squad trains hard",
    "Police corps investigates crime",
    "Chemical element combines easily",
    "Plain white shirt needed",
    "Enemy forces attack suddenly",
    "Strike while iron hot",
    "Political faction gains power",
    "派遣 workers need protection",
    "Musical instrument sounds beautiful",
    "Kitchen vessel holds water",
    "Ancient religion teaches wisdom",
    "Religious sect follows leader",
    "Deep marsh holds water",
    "Ask special favor please",
    "Student excel in math",
    "Outstanding performance recognized today",
    "Evaluate student progress carefully",
    "Film criticism appears harsh",
    "Rocky cape juts out",
    "Mountain promontory overlooks valley",
    "Violent storm approaches quickly",
    "Intense heat wave continues",
    "Personal virtue guides actions",
    "Public morality shapes society",
    "Spread blanket on grass",
    "Lay foundation for building",
    "Weave basket from reeds",
    "Fabric quality feels excellent",
    "Sharp edge cuts deeply",
    "Needle tip pierces fabric",
    "Ancient artifacts bequeath wisdom",
    "Parents leave behind memories",
    "Students follow teacher instructions",
    "Citizens obey traffic laws",
    "Volunteer aid helps victims",
    "Friends assist each other",
    "Theater curtain rises slowly",
    "First act begins now",
    "Coach supervise team practice",
    "Manager supervise daily operations",
    "Old warehouse stores grain",
    "Ancient granary holds rice",
    "Government carry out reforms",
    "Rich people donate money",
    "Students dislike difficult homework",
    "Many people hate violence",
    "Workers arrange meeting schedule",
    "Mechanic adjust engine settings",
    "Divine blessing brings peace",
    "Teacher favor hard workers",
    "Parents foster child development",
    "Farmers rear healthy livestock",
    "Nara prefecture famous temples",
    "Apple tree blooms spring",
    "Sharp sword cuts cleanly",
    "Knife blade needs sharpening",
    "Protesters resist government policies",
    "Citizens defy unjust laws",
    "Lightning wink lasts instant",
    "Instant coffee tastes bitter",
    "Deep wound requires stitches",
    "Words hurt more deeply",
    "Soldiers fight enemy bravely",
    "Workers struggle for rights",
    "Knife handle feels smooth",
    "Fabric pattern looks beautiful",
    "Court penalty seems harsh",
    "Prison sentence lasts years",
    "Teacher strict with students",
    "Judge stern but fair",
    "Military battle formation ready",
    "Summer camp welcomes children",
    "Soldier loyalty never wavers",
    "Dog faithfulness touches hearts",
    "Artist dye fabric bright",
    "Sunset tint sky orange",
    "Strong hemp rope holds",
    "Soft flax makes cloth",
    "Ancient clan rules territory",
    "Feudal fief pays taxes",
    "Deadline urge quick action",
    "Crowd press forward eagerly",
    "Ancient sword tells stories",
    "Sharp blade cuts paper",
    "Disease symptom appears suddenly",
    "Mental symptom requires attention",
    "Metal will fuse together",
    "Ice melt in sun",
    "Student bewildered by question",
    "Traveler perplexed by directions",
    "Theory based on evidence",
    "Success rely on effort",
    "Exercise benefit your health",
    "Business profit increases yearly",
    "Beautiful phrase captures meaning",
    "Complete sentence needs punctuation",
    "Animal belong natural habitat",
    "Species genus includes varieties",
    "Ancient emperor ruled wisely",
    "Powerful sovereign controls territory",
    "Friends congratulate wedding couple",
    "Family celebrate birthday together",
    "Castle moat protects inhabitants",
    "Ancient canal connects rivers",
    "Baby cry when hungry",
    "People weep during sadness",
    "Morning dew covers grass",
    "Reporter expose government corruption",
    "Sharp arrow hits target",
    "Dart game requires skill",
    "Firm grip prevents dropping",
    "Strong grasp holds tight",
    "Pirates attack merchant ships",
    "Prince succeed father throne",
    "Government tower stands tall",
    "Prime minister cabinet meets",
    "Tree shade provides coolness",
    "Mountain shadow grows longer",
    "Fisherman reel fishing line",
    "Clock wind up mechanism",
    "Crowd noisy during concert",
    "Children boisterous at playground",
    "Evil demon haunts castle",
    "Ancient magic protects kingdom",
    "Anti war protesters march",
    "Hot water heats quickly",
    "Bath time relaxes muscles",
    "Throw away broken items",
    "Discard old worn clothes",
    "Laws prohibit dangerous activities",
    "Transport goods by truck",
    "Import taxes increase prices",
    "Stay overnight at hotel",
    "Bathe children before bedtime",
    "Bury treasure under tree",
    "Internal organ needs surgery",
    "Dig hole for tree",
    "Register for college classes",
    "Deposit money in account",
    "Entrust task to assistant",
    "Traditional tatami mat comfortable",
    "Trillion dollars national debt",
    "Dark omen predicts trouble",
    "Wooden pillar supports roof",
    "Metal post marks boundary",
    "Charcoal burns very slowly",
    "Carbon footprint affects environment",
    "Company will employ graduates",
    "Hire qualified workers immediately",
    "Animal fat provides energy",
    "Bacon grease clogs drains",
    "Baking powder helps rise",
    "Face powder reduces shine",
    "Monks pray every morning",
    "Cigarette ash falls down",
    "Volcanic ash blocks sunlight",
    "Polish shoes until shiny",
    "Grind coffee beans fresh",
    "Office desk needs organizing",
    "Counter for animals increases",
    "Soft cotton feels comfortable",
    "Water will freeze tonight",
    "Glass bottle contains water",
    "Weather becomes very humid",
    "Skin feels quite moist",
    "Hot steam rises up",
    "Farmer will till soil",
    "Tractor plow breaks ground",
    "Pinch salt for flavor",
    "Insert key into lock",
    "Rain drop falls softly",
    "Water drip creates puddle",
    "Counter for ships increases",
    "Water will boil soon",
    "Parents consent to trip",
    "Everyone will agree eventually",
    "Tall pine tree grows",
    "Political faction gains power",
    "Photographer pinch lens cap",
    "Camera pinch zoom feature",
    "Government proclaim new policy",
    "King announce royal decree",
    "Lawyer sue for damages",
    "Customer complain about service",
    "Garden luxuriant with flowers",
    "Jungle overgrown with vines",
    "Teacher criticize student work",
    "Editor comment on manuscript",
    "Atomic nucleus contains protons",
    "Earth core extremely hot",
    "Worker tighten loose screws",
    "Parents tie shoes carefully",
    "Wild deer roam forest",
    "Majestic stag leads herd",
    "Meeting concerning budget issues",
    "Family settle inheritance dispute",
    "Fire destroy ancient building",
    "Species perish from earth",
    "Tall cedar tree grows",
    "Cryptomeria wood resists rot",
    "Driver avoid dangerous intersection",
    "Student evade difficult question",
    "Alliance form between nations",
    "Sacred oath binds warriors",
    "Court execute criminal sentence",
    "Manager tenacious about deadlines",
    "Sharp gun shoots accurately",
    "Old rifle needs cleaning",
    "Doctor fill prescription bottle",
    "Teacher allot homework assignments",
    "Patient spit bitter medicine",
    "Drunk person vomit alcohol",
    "Ship sail open sea",
    "Harbor boat wait offing",
    "Athlete yield to pressure",
    "Metal bend under weight",
    "Detective intuition proves correct",
    "Artist perception captures beauty",
    "Student penetrate difficult subject",
    "Rain thorough soak ground",
    "Priest purification ceremony begins",
    "Temple worship draws crowds",
    "Student apologize for mistake",
    "Family thank generous donor",
    "Navy warship patrols waters",
    "Merchant vessel carries cargo",
    "Traveler rest mountain hut",
    "Weary guest seek inn",
    "Cars collide dangerous intersection",
    "Armies clash battlefield tonight",
    "Fierce tiger hunts prey",
    "Angry drunkard causes trouble",
    "Ocean tide changes daily",
    "Fresh salt water flows",
    "Wise hermit lives mountains",
    "Powerful wizard casts spells",
    "Situation tense before meeting",
    "Urgent message requires attention",
    "Warrior endure physical pain",
    "Ninja stealth through shadows",
    "Crazy person needs help",
    "Mad scientist conducts experiments",
    "Thieves rob innocent victims",
    "Eagles snatch fish quickly",
    "Doctor diagnose rare disease",
    "Nurse examine patient carefully",
    "Ancient dragon guards treasure",
    "Imperial palace needs renovation",
    "Family debt increases yearly",
    "Bank loan requires collateral",
    "Buddhist monk meditates daily",
    "Catholic priest serves community",
    "Workers post safety notices",
    "Students put up decorations",
    "Noble count owns land",
    "English earl attends ceremony",
    "Pink plum blossoms bloom",
    "Sweet Japanese apricot ripens",
    "Article paragraph explains clearly",
    "Neck nape feels stiff",
    "Boss ridicule employee mistake",
    "Student laziness affects grades",
    "Carpenter handle tools expertly",
    "Manager deal with problems",
    "Diplomat ford dangerous waters",
    "Lawyer negotiate settlement terms",
    "Elegant woman attends party",
    "Gracious host welcomes guests",
    "Military cannon fires loudly",
    "Pirate gun threatens merchants",
    "Keep money safe pocket",
    "Baby sleep mother bosom",
    "Foolish person makes mistakes",
    "Stupid decision causes problems",
    "Snake tongue flicks quickly",
    "Musical reed vibrates air",
    "Broken item becomes useless",
    "Old pack horse carries",
    "Angry fellow causes trouble",
    "Loyal servant serves master",
    "Fresh beans taste good",
    "Green peas provide nutrition",
    "Police repress violent protests",
    "Parents control children behavior",
    "Brave samurai protects lord",
    "Servants wait upon master",
    "Drunk driver get drunk",
    "Traveler feel sick motion",
    "Human spine supports body",
    "Fish backbone provides structure",
    "Old turtle swims slowly",
    "Ancient tortoise lives centuries",
    "Stagnant marsh breeds mosquitoes",
    "Muddy swamp dangerous walking",
    "Police patrol city streets",
    "Guards go around perimeter",
    "Garbage stinking smell awful",
    "Fresh flowers smell wonderful",
    "Wedding jubilation fills church",
    "Family congratulate new parents",
    "Army invade enemy territory",
    "Weeds encroach garden space",
    "Buddha enlightenment teaches wisdom",
    "Student perceive hidden meaning",
    "Wood split along grain",
    "Fabric rend under pressure",
    "Police inquire about crime",
    "Scientists fathom ocean depths",
    "National flag waves proudly",
    "Colorful banner decorates street",
    "General brandish sword bravely",
    "Orchestra conductor command musicians",
    "Farmer plant rice plant",
    "Green paddy fields flood",
    "Body cell divide rapidly",
    "Mother womb protects baby",
    "Bridge suspend over river",
    "Success depend hard work",
    "Ancient hillock marks boundary",
    "Burial mound contains artifacts",
    "Natural disaster strikes suddenly",
    "Terrible calamity affects everyone",
    "Runner exhaust energy quickly",
    "Miser use up resources",
    "Woman marry loving man",
    "Beautiful bride wears white",
    "Garden luxuriant growth continues",
    "Radio frequency transmits signals",
    "Student notebook contains notes",
    "Theater curtain rises slowly",
    "Artist decorate ceramic vase",
    "Christmas ornament sparkles brightly",
    "Friend accompany shopping trip",
    "Guide bring with experience",
    "Ancient China trade goods",
    "Tang dynasty ruled wisely",
    "Chef append special sauce",
    "Cook garnish plate beautifully",
    "Teacher excuse student absence",
    "Court dismiss frivolous case",
    "Ancient peerage system complex",
    "Royal court rank matters",
    "Long corridor connects buildings",
    "Covered veranda provides shade",
    "Old comrade visits friend",
    "Loyal fellow helps neighbor",
    "Student cleverness impresses teacher",
    "Athlete agile movement wins",
    "Beautiful crane flies gracefully",
    "White stork nests rooftop",
    "Container emptiness allows filling",
    "Space void contains nothing",
    "Speech gist captures essence",
    "Traveler proceed mountain path",
    "Fire ardent passion burns",
    "Storm violent winds blow",
    "Massage chafe sore muscles",
    "Sandpaper rub wood smooth",
    "Yellow chrysanthemum blooms autumn",
    "Pink mum decorates garden",
    "Icy road slippery driving",
    "Children slide down hill",
    "Person naked bath time",
    "Artist nude model poses",
    "Child filial piety honors",
    "Daughter child duty respected",
    "Wealthy family residence large",
    "Governor mansion overlooks city",
    "Crane hoist heavy materials",
    "Cook fry fish oil",
    "Knight equestrian skills impressive",
    "Horse riding requires practice",
    "Old grave marked stone",
    "Ancient tomb holds treasures",
    "Young princess wears crown",
    "Pretty girl plays garden",
    "Material endure harsh weather",
    "Fabric proof water damage",
    "Student ought study harder",
    "Everyone by all means",
    "Anti war protest grows",
    "Anti virus software needed",
    "Clod earth sticks shoes",
    "Lump clay shapes easily",
    "Strangle weeds garden growth",
    "Constrict blood flow dangerous",
    "Seedling grows spring soil",
    "Sapling planted new garden",
    "Potato harvest this autumn",
    "Taro root tastes good",
    "Superfluous words waste time",
    "Uselessness brings no value",
    "Pottery class starts Monday",
    "Porcelain vase costs much",
    "Encourage students work harder",
    "Be diligent every single day",
    "Exhibit artwork gallery space",
    "Line up chairs meeting room",
    "Monkey climbs tall tree",
    "Ape swings branch branch",
    "Arrowroot starch cooking ingredient",
    "Kudzu vine spreads rapidly",
    "Umbrella protects from rain",
    "Parasol shields hot sun",
    "Inferiority complex affects confidence",
    "Be inferior means less",
    "Decline health worries family",
    "Wane moon becomes darker",
    "Waterfall creates beautiful mist",
    "Rapids flow through rocks",
    "Consolation helps grieving people",
    "Amusement park brings joy",
    "Pear tree blooms white",
    "Pear tree grows garden",
    "Habit forms over time",
    "Peculiarity makes person unique",
    "Bowl holds hot soup",
    "Basin fills with water",
    "Intestines digest food properly",
    "Guts require surgical care",
    "Banquet celebrates wedding anniversary",
    "Feast brings family together",
    "Hearth warms winter home",
    "Furnace heats entire building",
    "Ridgepole supports roof structure",
    "Ridge mountain offers view",
    "Den provides shelter animals",
    "Cave protects from storm",
    "Magnet attracts metal objects",
    "Porcelain dishes look elegant",
    "Destitution causes great suffering",
    "Scarce resources need conservation",
    "Gamble money casino games",
    "Wager bet sports team",
    "Latin language ancient Rome",
    "Kidnap victim needs rescue",
    "Flip coin decide winner",
    "Turn over new leaf",
    "Pearl necklace costs fortune",
    "Gem stone sparkles light",
    "Amass wealth over years",
    "Raise children with love",
    "Military officer leads troops",
    "Jailer guards prison cells",
    "Empress rules great wisdom",
    "Queen wears golden crown",
    "Sticky tape holds paper",
    "Glutinous rice makes dessert",
    "Urine test shows health",
    "Piss poor attitude problems",
    "Jaw muscle helps chewing",
    "Chin dimple looks cute",
    "Vow promises eternal love",
    "Swear oath court law",
    "Melancholy mood affects work",
    "Grieve loss beloved pet",
    "Bud opens spring morning",
    "Sprout grows from seed",
    "Axis rotation earth science",
    "Pivot point changes direction",
    "Torment others shows cruelty",
    "Scold child bad behavior",
    "Basin lantern festival celebrates",
    "Lantern festival lights sky",
    "Villain causes trouble town",
    "Bad luck follows superstition",
    "Commoner lives simple life",
    "Bastard child needs love",
    "Cuff shirt needs repair",
    "Hem dress too long",
    "Secluded cabin forest peace",
    "Confined space feels cramped",
    "Clumsy person drops things",
    "Unskillful attempt fails badly",
    "Calendar shows important dates",
    "Almanac predicts weather patterns",
    "Tumor grows rapidly concerning",
    "Swelling reduces ice treatment",
    "Barbarian tribes ancient history",
    "Savage behavior needs correction",
    "Hard up money problems",
    "Destitute family needs help",
    "Embarrass others shows meanness",
    "Humiliate people creates enemies",
    "Aroused anger dangerous emotion",
    "Resent unfair treatment naturally",
    "Gloom depression needs treatment",
    "Depression affects many people",
    "Repeatedly asking same question",
    "Recur problems need solutions",
    "Horizontal line crosses vertical",
    "Weft weaves through warp",
    "Attractive person draws attention",
    "Bewitching smile charms everyone",
    "Pork tastes good barbecue",
    "Pig farm provides meat",
    "Halberd weapon medieval times",
    "Arms race threatens peace",
    "Forge metal fire hammer",
    "Discipline child gentle guidance",
    "Watchtower guards against enemies",
    "Lookout point offers view",
    "Sire horse breeding important",
    "Good belt holds pants",
    "Sated feeling after meal",
    "Tired of same routine",
    "Rotation earth creates day",
    "Spin wheel changes fortune",
    "Two-mat area traditional measure",
    "Thirty-six sq ft small",
    "Scold child teaches lesson",
    "Reprove behavior shows care",
    "Gorge river carved rock",
    "Ravine deep narrow valley",
    "Gutter collects rain water",
    "Ditch beside road drainage",
    "Rut wheel track mud",
    "Wheel track shows direction",
    "Tile roof protects house",
    "Gram measure weighs food",
    "Epidemic spreads disease quickly",
    "Pestilence affects entire region",
    "Fan cools hot summer",
    "Folding fan traditional Japanese",
    "Fist clenched anger emotion",
    "Handfull berries taste sweet",
    "The latter option seems",
    "Duplicate key opens door",
    "Fermentation brewing beer process",
    "Brewing tea requires patience",
    "Thwart plans prevent success",
    "Separate from family difficult",
    "Mulberry tree leaves feed",
    "Mulberry tree grows quickly",
    "Captive bird sings sadly",
    "Barbarian invasion ancient fear",
    "Hug children shows love",
    "Embrace new opportunities always",
    "Enclosure quarters military base",
    "Quarters soldiers sleep barracks",
    "Curse spell magical thinking",
    "Spell word correctly important",
    "Washing selection process careful",
    "Selection criteria very strict",
    "Old man tells stories",
    "Venerable elder respected community",
    "Silk fabric feels smooth",
    "Silk fabric expensive luxury",
    "Musical score shows notes",
    "Genealogy traces family history",
    "Mausoleum honors dead leader",
    "Imperial tomb ancient burial",
    "Flute music sounds beautiful",
    "Clarinet player needs practice",
    "Daybreak brings new hope",
    "Dawn chorus birds sing",
    "Column newspaper article interesting",
    "Handrail helps people stairs",
    "Glossy surface reflects light",
    "Luster pearl shows quality",
    "Deceit cheat people wrong",
    "Cheat others shows weakness",
    "Bowstring chord music instrument",
    "Chord progression sounds harmonious",
    "Bubbles foam soap water",
    "Foam waves crash shore",
    "Rice cake mochi traditional",
    "Mochi sticky sweet dessert",
    "Descendants elder brother family",
    "Elder brother protects siblings",
    "Chinquapin mallet tool woodworking",
    "Mallet hammer wood projects",
    "Whirlpool eddy water dangerous",
    "Eddy current flows backward",
    "Recital singing performance beautiful",
    "Singing voice needs training",
    "Hegemony supremacy power control",
    "Supremacy one group others",
    "Equilibrium measuring rod balance",
    "Measuring rod shows distance",
    "Lewdness licentiousness behavior inappropriate",
    "Licentiousness shows poor character",
    "Chastise punish child behavior",
    "Punish wrongdoer justice system",
    "Brocade fine dress expensive",
    "Fine dress special occasion",
    "Cash bad habit spending",
    "Bad habit needs breaking",
    "Ugly unclean appearance unfortunate",
    "Unclean house needs cleaning",
    "Dark blue navy blue",
    "Navy blue uniform looks",
    "Mediator go-between helps negotiations",
    "Go-between arrange marriage traditional",
    "Intercept interrupt message delivery",
    "Interrupt conversation considered rude",
    "Kettle cauldron boils water",
    "Cauldron large pot cooking",
    "Stalk stem plant grows",
    "Stem flower needs water",
    "Ignore despise people wrong",
    "Despise others shows arrogance",
    "Pardon forgiveness shows mercy",
    "Forgiveness heals broken relationships",
    "Repay reward good deed",
    "Reward effort shows appreciation",
    "Be crowned with success",
    "Live under same roof",
    "Big Dipper ten sho",
    "Ten sho traditional measure",
    "Husk nut shell protects",
    "Nut shell hard outer",
    "Tread step on ground",
    "Step on careful where",
    "Confucian scholar studies philosophy",
    "Scholar wisdom benefits society",
    "Awakening disillusion reality check",
    "Disillusion comes with experience",
    "Cavern den animals hide",
    "Den safe place rest",
    "Towel hanging scroll bathroom",
    "Hanging scroll traditional art",
    "Mourning abhor death sadness",
    "Abhor violence peaceful solution",
    "Play with tamper objects",
    "Tamper evidence illegal activity",
    "Jealousy envy destroys relationships",
    "Envy others wastes energy",
    "Abuse revile people wrong",
    "Revile others shows anger",
    "Scold chastise child behavior",
    "Chastise wrongdoer appropriate response",
    "Leaping up jumping high",
    "Jumping exercise good health",
    "Firefly glows summer night",
    "Plug up shut up",
    "Shut up hole wall",
    "Gland lymph gland body",
    "Lymph gland fights infection",
    "Beam girder supports structure",
    "Girder steel construction material",
    "Melting smelting metal process",
    "Smelting ore produces metal",
    "Feel ashamed shy behavior",
    "Shy person avoids crowds",
    "Widow minority population group",
    "Minority rights need protection",
    "Furrow thirty tsubo measurement",
    "Thirty tsubo traditional area",
    "Legitimate wife direct descent",
    "Direct descent family line",
    "Barracks police station building",
    "Police station serves community",
    "Go upstream retrace river",
    "Retrace steps find way",
    "Gunwale side of ship",
    "Side of ship needs",
    "Frost hoar-frost winter morning",
    "Hoar-frost covers grass blades",
    "Martyrdom follow by resigning",
    "Follow by resigning honor",
    "Spinning textile industry important",
    "Textile factory employs many",
    "Covet indulge in wealth",
    "Indulge in luxury spending",
    "Squeeze cheat honest people",
    "Cheat customers wrong business",
    "Broil parch food cooking",
    "Parch corn makes snack",
    "Matrimony relatives by marriage",
    "Relatives by marriage attend",
    "Spots speckles animal fur",
    "Speckles pattern looks natural",
    "Hades the underworld mythology",
    "The underworld ancient belief",
    "Quasi semi official status",
    "Semi official documents need",
    "Reef sunken rock dangerous",
    "Sunken rock ships avoid",
    "Noodles wheat flour food",
    "Wheat flour makes bread",
    "Measuring box rise up",
    "Rise up early morning",
    "Decrease consume resources carefully",
    "Consume less save money",
    "Glassy lapis lazuli stone",
    "Lapis lazuli beautiful blue",
    "Skewer spit cooking meat",
    "Spit roast over fire",
    "Condolences mourning family sadness",
    "Mourning period lasts months",
    "VIP guest receives treatment",
    "Guest room prepared visitors",
    "Fill in inlay wood",
    "Inlay decoration adds beauty",
    "Diarrhea dysentery illness symptoms",
    "Dysentery requires medical care",
    "Excessive overflow water damage",
    "Overflow pipe prevents flooding",
    "Convex beetle brow shape",
    "Beetle brow looks prominent",
    "Levy ode poetry form",
    "Ode celebrates heroic deeds",
    "Arc arch bridge structure",
    "Arch supports heavy weight",
    "Brown woolen fabric warm",
    "Woolen sweater keeps comfortable",
    "Rin ten sen currency",
    "Ten sen small amount",
    "Rectify straighten crooked line",
    "Straighten bent metal rod",
    "Silkworm caterpillar produces silk",
    "Caterpillar transforms beautiful butterfly",
    "Spread out diffuse light",
    "Diffuse sunlight through clouds",
    "Frugal economy saves money",
    "Economy improves living standards",
    "Selfish arbitrary decisions unfair",
    "Arbitrary rules confuse people",
    "Clear the land reclaim",
    "Reclaim desert make fertile",
    "Relay in turn message",
    "In turn each speaks",
    "Censure criminal investigation court",
    "Criminal investigation requires evidence",
    "Dairy products whey cheese",
    "Whey protein builds muscle",
    "Pox smallpox disease history",
    "Smallpox vaccination saves lives",
    "Yearn for aspire to",
    "Aspire to greatness always",
    "Third class C grade",
    "C grade needs improvement",
    "Axe catty tool weight",
    "Catty traditional weight measure",
    "Obituary death notice newspaper",
    "Death notice informs community",
    "Transcribe mimeograph documents copying",
    "Mimeograph machine copies papers",
    "Cocoon pupa butterfly development",
    "Pupa stage insect growth",
    "Imperial seal sigil authority",
    "Sigil magical symbol power",
    "Square character style correctness",
    "Correctness writing shows education",
    "Come off peel skin",
    "Peel orange eat fruit",
    "Basket devote oneself work",
    "Devote oneself family care",
    "Cheek jaw facial features",
    "Jaw bone strong structure",
    "Magnet metal physics science",
    "Metal conducts electricity well",
    "Forge hammer blacksmith work",
    "Hammer tool builds things",
    "Bamboo furniture natural material",
    "Furniture arrangement affects mood",
    "Shallow water fish swim",
    "Fish need clean water",
    "Steep dangerous mountain path",
    "Dangerous animals avoid humans",
    "Dog bone structure anatomy",
    "Bone density affects health",
    "Brain precision surgical operation",
    "Precision instruments measure accurately",
    "Earthquake shake buildings foundation",
    "Shake hands greeting custom",
    "South Korea technology exports",
    "Technology advances improve life",
    "Shoulder responsibility burden sharing",
    "Burden sharing helps community",
    "One hundred million dollars",
    "Million people live city",
    "Reverse car parking lot",
    "Car needs regular maintenance",
    "Eagle wing impressive sight",
    "Wing span measures distance",
    "Modern agriculture efficient methods",
    "Agriculture feeds world population",
    "Bake bread oven heat",
    "Bread staff of life",
    "Medical pain treatment necessary",
    "Pain signals body problems",
    "Lower waist back injury",
    "Waist measurement clothing size",
    "Anti government protest march",
    "Anti corruption campaign starts",
    "Lie falsehood hurts relationships",
    "Falsehood destroys trust completely",
    "Persimmon shingle roof repair",
    "Shingle protects house weather",
    "Wick marrow candle light",
    "Marrow bone nutrition source",
    "Come apart rip fabric",
    "Rip paper careful handling",
    "Elbow arm joint movement",
    "Arm muscle needs exercise",
    "Foot of mountain foothills",
    "Foothills provide scenic view",
    "Yearn after long for",
    "Long for home country",
    "Commander leading troops battle",
    "Leading troops requires courage",
    "Lacquer varnish wood protection",
    "Varnish makes furniture shine",
    "Bartending serve sake customers",
    "Serve sake traditional ceremony",
    "Compensation reparations war damages",
    "Reparations help rebuild nation",
    "Thirst dry up desert",
    "Dry up resources conservation",
    "Bridegroom son-in-law family",
    "Son-in-law joins family",
    "Rue be sorry mistake",
    "Be sorry hurt feelings",
    "Marrow pith bone structure",
    "Pith essential plant part",
    "Tusk fang animal weapon",
    "Fang snake venomous bite",
    "Throat choked food stuck",
    "Choked feeling panic attack",
    "Above-stated the said document",
    "The said person witness",
    "Tempering refine metal process",
    "Refine oil petroleum industry",
    "Scaffold cleat construction support",
    "Cleat holds rope boat",
    "Blind blind man needs",
    "Blind man walks stick",
    "Whale cetacean ocean mammal",
    "Cetacean research marine biology",
    "Rowboat small boat fishing",
    "Small boat lake recreation",
    "Carbuncle ulcer skin infection",
    "Ulcer stomach pain symptoms",
    "Vat tub brewing process",
    "Tub bath water relaxing",
    "Paddy ridge levee water",
    "Levee protects flood damage",
    "Tempt seduce innocent people",
    "Seduce others wrong behavior",
    "Kidney loins body organs",
    "Loins strength physical power",
    "Envious be jealous others",
    "Be jealous wastes energy",
    "Secrete ooze liquid substance",
    "Ooze mud swamp ground",
    "Sulphur sulfur chemical element",
    "Sulfur smell strong odor",
    "Mimic aim at target",
    "Aim at goal achievement",
    "Confer narrative academic degree",
    "Narrative story tells events",
    "Tracks mark animal footprints",
    "Mark spot remember location",
    "Seaweed duckweed pond plants",
    "Duckweed floats water surface",
    "Mosquito gnat insects bite",
    "Gnat swarm summer evening",
    "Horse chestnut Japanese zelkova",
    "Japanese zelkova tree grows",
    "Casting mint metal coins",
    "Mint fresh herb cooking",
    "Coffin casket burial container",
    "Casket expensive funeral cost",
    "Nitrate saltpeter chemical compound",
    "Saltpeter preserves meat food",
    "Tariff crop tax government",
    "Crop tax farmers pay",
    "Emulate imitate good behavior",
    "Imitate successful people habits",
    "Discreet reverently respectful manner",
    "Reverently bow religious ceremony",
    "Mortar quern grinding grain",
    "Quern stone mill flour",
    "Quasi semi official position",
    "Semi official recognition government",
    "Pine tree forest evergreen",
    "Pine tree grows mountain",
    "Stay overnight hotel room",
    "Stay overnight friend house",
    "Internal organ body function",
    "Internal organ needs care",
    "Counter for animals count",
    "Counter for animals pets",
    "Counter for ships harbor",
    "Counter for ships navy",
    "Gauze thin silk medical",
    "Thin silk fabric expensive",
    "Pierce ten momme weight",
    "Ten momme traditional measure",
    "Decameron ten-day period story",
    "Ten-day period vacation time",
    "Bow weapon arrow shooting",
    "Bow string instrument music",
    "Slap strike punishment physical",
    "Strike match light fire",
    "Shield escutcheon protection armor",
    "Escutcheon family coat arms",
    "Nest rookery bird home",
    "Rookery colony seabirds breed",
    "Undefiled pure clean water",
    "Pure clean mountain air",
    "Formerly once upon time",
    "Once upon time story",
    "Fasten halt stop movement",
    "Halt traffic light signal",
    "Stick paste on wall",
    "Paste on paper glue",
    "Animal sacrifice offering ritual",
    "Offering gift religious ceremony",
    "Sail canvas boat wind",
    "Canvas painting artist creates",
    "Confused mix up papers",
    "Mix up ingredients cooking",
    "Self-effacing humble person character",
    "Humble person shows respect",
    "Drum beat rhythm music",
    "Beat rhythm dance song",
    "Chic pure fashion style",
    "Pure clean drinking water",
    "Register record book keeping",
    "Record book historical events",
    "Grate rub cheese cooking",
    "Rub skin massage therapy",
    "Claw nail animal feature",
    "Nail hammer construction tool",
    "Healing cure medical treatment",
    "Cure disease doctor prescription",
    "Sew stitch fabric together",
    "Stitch wound medical procedure",
    "Grasp faggot bundle sticks",
    "Faggot wood fire burning",
    "Cliff bluff dangerous edge",
    "Bluff poker game strategy",
    "Black ink Mexico writing",
    "Mexico country North America",
    "Dike bank water control",
    "Bank money financial institution",
    "Cultivate foster children development",
    "Foster care child protection",
    "Animal fat lard cooking",
    "Lard traditional cooking ingredient",
    "Bases fort military installation",
    "Fort historical defense structure",
    "Trunk torso body part",
    "Torso exercise physical fitness",
    "Mark footprint evidence tracking",
    "Footprint sand beach walking",
    "Dormitory hostel student housing",
    "Hostel budget travel accommodation",
    "Unlucky misfortune bad luck",
    "Misfortune happens good people",
    "Pregnancy with child expecting",
    "With child woman carries",
    "Yell cry loud voice",
    "Cry tears emotional response",
    "Jealous envious negative emotion",
    "Envious people unhappy others",
    "Honey nectar sweet natural",
    "Nectar flower attracts bees",
    "Tombstone monument grave marker",
    "Monument honors historical event",
    "Get thin lean lose",
    "Lean meat healthy protein",
    "However provided that condition",
    "Provided that weather permits",
    "Exhort urge encourage action",
    "Urge people vote election",
    "Grudge show resentment anger",
    "Show resentment hurt feelings",
    "Plantation planting crops agriculture",
    "Planting seeds spring season",
    "Womb uterus female reproduction",
    "Uterus organ pregnancy development",
    "Bee wasp insects pollinate",
    "Wasp sting painful swelling",
    "Lead black lead metal",
    "Black lead pencil writing",
    "Receive undergo medical treatment",
    "Undergo surgery hospital procedure",
    "Imperial edict decree government",
    "Decree law official announcement",
    "Meritorious deed merit recognition",
    "Merit award excellent work",
    "Anti drug campaign successful",
    "Medical treatment requires patience",
    "Pain in lower waist",
    "Bake fresh bread daily",
    "Modern agriculture uses technology",
    "Eagle wing span impressive",
    "Reverse the car carefully",
    "Bamboo furniture looks elegant",
    "Earthquake can shake buildings",
    "One hundred million dollars",
    "Shoulder responsibility with others",
    "Shallow breathing indicates stress",
    "Steep slope is dangerous",
    "South Korea exports technology",
    "Dog bone density decreases",
    "Brain surgery requires precision",
    "Fireworks explode in sky",
    "Fabric will stretch easily",
    "Introduce new policy changes",
    "Signs prohibit smoking here",
    "Paper sheet for writing",
    "First grandchild brings joy",
    "Building height exceeds regulations",
    "Connect wires to battery",
    "Building lean against wall",
    "Postpone meeting until Monday",
    "Submarine can submerge deeply",
    "Europe exports fine products",
    "Overnight delivery costs more",
    "Thin twig snapped easily",
    "Longevity runs in family",
    "Clear fluid fills container",
    "Cloth sack holds grain",
    "Car needs more fuel",
    "Cats bathe themselves daily",
    "Never be troubled unnecessarily",
    "Factory emissions pollute air",
    "Cat rear legs strong",
    "Happy teardrop of joy",
    "Cold sweat indicates fear",
    "Organ music plays softly",
    "Knee replacement surgery successful",
    "Rain drips from eaves",
    "Dig deeper for water",
    "Club membership has benefits",
    "Instruction manual is helpful",
    "Tatami mat needs replacement",
    "Sewing thread tangles easily",
    "Glass cylinder holds water",
    "Fresh barley makes beer",
    "Easter egg hunt fun",
    "Pray for world peace",
    "Sugar dissolve in water",
    "Desk lamp provides light",
    "Wild animals need protection",
    "Cotton candy melts quickly",
    "Freeze frame shows details",
    "Steam engine powers train",
    "Stomach ache painful",
    "Suburb has good schools",
    "Copper pot conducts heat",
    "Turtle shell provides protection",
    "Ships anchor in harbor",
    "Boil eggs for breakfast",
    "Wisteria vine climbs high",
    "Muscles extend during movement",
    "Pine nuts taste good",
    "Earthquake shake building foundations",
    "Evil demon haunts castle",
    "Lemon acid taste sour",
    "Beautiful poem touches hearts",
    "Government abolish old laws",
    "Thin gauze covers wound",
    "Child filial piety respected",
    "Doctor look to patient",
    "Nurse attend sick people",
    "Blood vein carries oxygen",
    "Heart pulse beats regularly",
    "Green turf covers field",
    "Fresh lawn needs water",
    "Choir chant hymns beautifully",
    "Students recite poetry together",
    "Baby nativity brings joy",
    "Child be born healthy",
    "Arrow pierce target center",
    "Weight ten momme gold",
    "Crowd stirred up excitement",
    "Warrior be roused battle",
    "Pink cherry blossom blooms",
    "Sweet cherry fruit ripens",
    "Cheese mellow with age",
    "Fruit ripen summer sun",
    "Factory repudiate union demands",
    "School exclude problem students",
    "Glass transparent window clear",
    "Perfume permeate entire room",
    "Parents abandon bad habits",
    "Never throw away hope",
    "Carpenter plane wood smooth",
    "Cook sharpen kitchen knives",
    "Musician play music beautifully",
    "Ambassador speak to ruler",
    "Police arrest dangerous criminal",
    "Hunter capture wild animal",
    "Hot flame burns brightly",
    "Forest blaze spreads quickly",
    "Comfortable chair supports back",
    "Stadium seat holds thousands",
    "Wheat ear of grain",
    "Flower spike grows tall",
    "Farmer domesticate wild animals",
    "Parents feed children daily",
    "Weather still cold today",
    "Furthermore more rain expected",
    "Common vulgar language offends",
    "Local customs vary widely",
    "Healthy liver processes toxins",
    "Brave pluck saves day",
    "Citizens resist government oppression",
    "Army oppose enemy forces",
    "Bitter astringent taste unpleasant",
    "Child reluctant share toys",
    "Sheep pasture green fields",
    "Farmer breed cattle carefully",
    "Doctor refrain prescribing medicine",
    "Parents moderate children behavior",
    "Noise distract student concentration",
    "Lies confuse honest people",
    "Religious commandment guides behavior",
    "Moral precept teaches virtue",
    "Muscle thigh supports weight",
    "Pants crotch tears easily",
    "Criminals threaten innocent victims",
    "Bullies coerce weaker students",
    "Blanket cover sleeping child",
    "Revolution overturn old government",
    "Tragic pathetic story sadness",
    "Mother grief overwhelming loss",
    "Rich fertilizer helps plants",
    "Animal manure improves soil",
    "Student humility earns respect",
    "Driver be careful road",
    "Time permanence never changes",
    "Mountain distant appears blue",
    "Makeup eyebrow looks natural",
    "Furrowed brow shows concern",
    "Student repel teacher criticism",
    "Army refuse enemy demands",
    "Businessman look back career",
    "Committee review budget proposal",
    "Food rot hot weather",
    "Wood decay over time",
    "Sad orphan needs family",
    "Lonely alone person cries",
    "Danger be imminent storm",
    "Train draw near station",
    "Army repel enemy attack",
    "Soldiers retreat battle line",
    "Police catch burglar house",
    "Ancient rebel fights king",
    "Skilled artisan creates beauty",
    "Master workman builds furniture",
    "Sinner repent past mistakes",
    "Student regret missing class",
    "Doctor treat patient kindly",
    "Friends encounter old classmate",
    "People adore movie star",
    "Child revere wise teacher",
    "Heavy fruit droop tree",
    "Bridge suspend over river",
    "River branch off mountain",
    "Road fork different directions",
    "Famous haiku poet writes",
    "Stage actor performs play",
    "Line diagonal crosses square",
    "Building slanting needs repair",
    "Young lass dances gracefully",
    "Pretty young woman sings",
    "Building collapse heavy earthquake",
    "Soldier fall into trap",
    "Insurance reparation covers damage",
    "Student make up for",
    "Museum specimen shows history",
    "Judge take warning from",
    "Teacher recommend good book",
    "Doctor advise healthy diet",
    "Family interment ceremony solemn",
    "Soldier bury fallen comrade",
    "Wood char black fire",
    "Student hurry finish homework",
    "Supreme courts hear cases",
    "Ancient imperial court rules",
    "Beautiful purple flower blooms",
    "Rich violet fabric expensive",
    "Stone inscription tells story",
    "Artist signature identifies work",
    "Farmer sickle cuts grain",
    "Garden scythe trims grass",
    "Dangerous germ spreads disease",
    "Mushroom fungus grows forest",
    "King defer royal decision",
    "Company turnover employees regularly",
    "Fierce lion hunts prey",
    "Storm rave through city",
    "Team accomplish difficult goal",
    "Student achieve academic success",
    "Bird wing helps flying",
    "Airplane plane flies high",
    "Ghost uncanny appearance frightens",
    "Strange weird noise scares",
    "Heavy front door opens",
    "Book title page blank",
    "Ruler measurement twelve inches",
    "Human foot ten toes",
    "Taxi fare costs money",
    "Parking fee expensive downtown",
    "Secret spy gathers information",
    "Army scout reports enemy",
    "Clear lucidity helps thinking",
    "Water be clear spring",
    "Person especially talented music",
    "Recipe particularly delicious today",
    "Rope slacken under weight",
    "Rules loosen strict requirements",
    "Sweet perfume smells lovely",
    "Garden fragrant roses bloom",
    "Terrible wretched living conditions",
    "Dictator cruel treatment citizens",
    "Evil tyrannize innocent people",
    "Government oppress political opponents",
    "Liquid congeal cold temperature",
    "Students concentrate studying hard",
    "Janitor wipe dirty floor",
    "Mother mop spilled milk",
    "Honest upright person respected",
    "Woman chastity valued society",
    "Personal ethics guide behavior",
    "Close companion helps friend",
    "Volcano erupt hot lava",
    "Fountain spout water high",
    "Wise old woman advice",
    "Kind grandma bakes cookies",
    "Elegant small table dining",
    "Waiter carries food tray",
    "Bright vermilion paint color",
    "Red cinnabar mineral valuable",
    "Boat drift ocean currents",
    "Balloon float high sky",
    "Deep loneliness hurts heart",
    "Library quietly peaceful place",
    "Student sigh tired studying",
    "Mother lament child behavior",
    "Peaceful Zen meditation practice",
    "Monk silent meditation daily",
    "Dictator cruel harsh punishment",
    "Judge severe sentence criminal",
    "Funny cartoon makes laugh",
    "Artist involuntary hand movement",
    "Thick fog blocks vision",
    "Morning mist covers valley",
    "Shirt sleeve too long",
    "Bird wing feathers beautiful",
    "Athlete robust physical condition",
    "Young manhood brings responsibility",
    "Magazine decameron ten stories",
    "Contest ten day period",
    "Artist carve beautiful sculpture",
    "Craftsman engrave metal plate",
    "Strong chain holds prisoner",
    "Heavy irons restrict movement",
    "Machine crush hard rocks",
    "Hammer smash glass pieces",
    "Line vertical stands straight",
    "Rope length measures distance",
    "Woman cosmetics look beautiful",
    "Bride adorn wedding dress",
    "Student disconcerted test question",
    "Driver be confused directions",
    "Picture frame holds photograph",
    "Building framework supports structure",
    "Train deviate normal route",
    "Wealthy idleness breeds laziness",
    "Mother pity sick child",
    "Miser be sparing of",
    "Beautiful harp music plays",
    "Traditional koto sounds lovely",
    "Government vicarious represents people",
    "Teacher surrogate parent role",
    "Audience clap enthusiastic performance",
    "Musician beat time rhythm",
    "Traveler encounter dangerous storm",
    "Student meet with teacher",
    "Large pot cooks stew",
    "Frying pan heats oil",
    "Archer bow shoots arrow",
    "Hero overcome difficult challenge",
    "Soldier kindly helps civilians",
    "Brave gall bladder surgery",
    "Strong nerve handles pressure",
    "Police truss dangerous criminal",
    "Court arrest suspected thief",
    "Medicine tranquilize anxious patient",
    "Diplomat appease angry crowd",
    "Student regret failing exam",
    "Employee bear a grudge",
    "Truth appear after investigation",
    "Ghost existing haunted house",
    "Spring water boil underground",
    "Bread ferment warm temperature",
    "Strategic chess piece moves",
    "Master Japanese chess player",
    "Craftsman adroit skilled hands",
    "Artist skilled beautiful painting",
    "Sponge immersed water completely",
    "Rain soak ground thoroughly",
    "Sweet peach fruit ripens",
    "Pink peach tree blooms",
    "Prison isolate dangerous criminals",
    "Schedule alternate work shifts",
    "Woman pregnancy requires care",
    "Doctor conception explains carefully",
    "Student cram school studies",
    "Teacher private school teaches",
    "Coastal lagoon attracts birds",
    "River inlet provides shelter",

    // RA sentences
    "Rain falls down",
    "Race against time",
    "Radio plays music",
    "Random act kindness",
    "Rapid fire questions",
    "Rare bird spotted",
    "Rate of change",
    "Rather be fishing",
    "Raw fish sushi",
    "Ray of sunshine",
    "Reach for stars",
    "React quickly now",
    "Read between lines",
    "Ready when you",
    "Real deal here",
    "Really good news",
    "Reason for hope",
    "Recipe calls for",
    "Record breaking performance",
    "Red rose blooms",

    // RI sentences
    "Rice and beans",
    "Rich chocolate cake",
    "Ride the wave",
    "Right on time",
    "Ring door bell",
    "Risk it all",
    "River runs deep",
    "Road trip planned",
    "Rock and roll",
    "Role model needed",
    "Room service please",
    "Root of problem",
    "Rose garden blooms",
    "Round trip ticket",
    "Route map shows",
    "Royal family visits",
    "Rubber duck squeaks",
    "Ruby red lips",
    "Rule of thumb",
    "Run for cover",

    // RU sentences
    "Run very fast",
    "Rubber duck squeaks",
    "Ruby red gemstone",
    "Rule book says",
    "Rumor has it",
    "Rural countryside beautiful",
    "Rush hour traffic",
    "Rust never sleeps",

    // RE sentences
    "Read the book",
    "Ready or not",
    "Real deal here",
    "Reason for hope",
    "Record your thoughts",
    "Red carpet event",
    "Reduce reuse recycle",
    "Reflect on past",
    "Regular maintenance needed",
    "Relax and unwind",
    "Remember good times",
    "Rent is due",
    "Repeat after me",
    "Report card grades",
    "Request more information",
    "Research paper due",
    "Reserve your spot",
    "Respect your elders",
    "Rest in peace",
    "Result speaks volumes",

    // RO sentences
    "Rock and roll",
    "Road trip adventure",
    "Room for improvement",
    "Rose garden beautiful",
    "Rotate the tires",
    "Round trip ticket",
    "Route home clear",
    "Royal treatment received",
    "Rubber meets road",
    "Run for office",

    // WA sentences
    "Walk the dog",
    "Wait your turn",
    "Wake up early",
    "Wall needs paint",
    "Want some coffee",
    "War and peace",
    "Warm summer day",
    "Watch the game",
    "Water the plants",
    "Wave goodbye now",
    "Way to go",
    "Weak signal strength",
    "Wear warm clothes",
    "Weather looks good",
    "Wedding bells ring",
    "Week goes fast",
    "Welcome home party",
    "Well done today",
    "West coast trip",
    "What time now",

    // WO sentences
    "Work hard today",
    "World peace hope",
    "Worry about nothing",
    "Worth the wait",
    "Wow factor high",
    "Wonderful day ahead",
    "Wood fire warm",
    "Word spreads fast",
    "Worse things happen",
    "Worship service starts",

    // N sentences (standalone)
    "An apple day",
    "In the house",
    "On the table",
    "Can you help",
    "Run and play",
    "Sun and moon",
    "Fun and games",
    "One more time",
    "Ten green bottles",
    "When we meet",
    
    // Additional sentences for coverage
    "Anti-virus software protects",
    "Anti-bacterial soap kills germs",
    "Cape headland overlooks ocean",
    "We stay temporarily here",
    "Portrait shows resemblance",
    "He gave consent today",
    "Fragrant flowers bloom",
    "Slave worked hard daily",
    "Bag holds rice grain",
    "Door hinge needs oil",
    "She pining for home",
    "Delusion clouds judgment",
    "Pursue your dreams always",
    "Don't ridicule others ever",
    "Partner helps me work",
    "Bowl holds hot soup",
    "We lament his loss",
    "King grant special favor",
    "Distress shows on face",
    "Wood decay over time",
    "Bills accumulate each month",
    "Twirl ribbon around finger",
    "Plants wither without water",
    "Firefly glows at night",
    "Poem has beautiful rhyme",
    "Extract excerpt from book",
    "Quasi-legal agreement signed",
    "Semi-automatic car shifts",
    "Wholesale prices are lower",
    "One rin costs little",
    "Take turns alternate playing",
    "Work make progress slowly",
    "Distribute flyers to crowd",
  ],

  medium: [
    // Continue with medium sentences containing specific characters...
    "The weather is absolutely beautiful today and everyone should take advantage of it",
    "I really enjoy reading fascinating books in the early morning hours before work",
    "She carefully teaches wonderful music at the local elementary school downtown",
    "We are actively planning an amazing trip to the Rocky Mountains this summer",
    "The fantastic restaurant serves incredibly delicious authentic Japanese food daily",
    "I simply cannot find my important keys anywhere in the entire house today",
    "She speaks three different languages fluently and travels internationally often",
    "The happy children are playing energetically in the beautiful backyard garden",
    "We watched an incredibly interesting movie about ancient Roman history last night",
    "The old computer definitely needs to be professionally repaired very soon",
    "I absolutely love to cook traditional family recipes from my dear grandmother",
    "She consistently practices relaxing yoga every single morning before going to work",
    "The massive library has thousands of fascinating books on every conceivable subject",
    "We took a wonderfully long walk through the peaceful forest this afternoon",
    "The talented artist painted a breathtakingly beautiful landscape of the rolling countryside",
    "I desperately need to finish this important project before the approaching deadline",
    "She always lovingly remembers to water her precious plants very carefully",
    "The impressive museum displays amazing artifacts from many different ancient cultures",
    "We learned extensively about renewable solar energy in our advanced science class",
    "The local bakery makes incredibly fresh bread every single morning without fail",
    "I genuinely enjoy listening to beautiful classical music while studying mathematics",
    "She volunteers regularly at the animal shelter on weekends helping homeless pets",
    "The experienced mechanic fixed our broken car in just two short hours",
    "We celebrated our anniversary at a fancy romantic restaurant downtown last week",
    "The patient teacher explained the complex math problem step by step clearly",
    "I absolutely cannot understand why the office printer is not working today",
    "She grows delicious tomatoes and carrots in her beautiful backyard garden plot",
    "The wise doctor recommended getting much more exercise and adequate sleep daily",
    "We discussed the critical importance of recycling with our concerned environmental neighbors",
    "The amazing concert was absolutely incredible and very emotionally inspiring for everyone",

    // Additional medium sentences covering comprehensive translations
    "The first place winner received a magnificent golden trophy from the ceremony officials",
    "One small step for humanity represents a giant leap toward universal peace and understanding",
    "Two different cultures can learn to respect each other through meaningful dialogue and cooperation",
    "The second chance opportunity allowed him to demonstrate his true potential and hidden talents",
    "Three wise mentors shared their valuable life experiences with the eager young students",
    "The third attempt finally succeeded after learning from previous mistakes and careful planning",
    "Four seasons bring different natural beauty and unique opportunities for outdoor recreational activities",
    "Five fundamental principles guide our organization toward ethical business practices and sustainable growth",
    "Six dedicated volunteers worked tirelessly to organize the community charity event for local families",
    "Seven ancient wonders of the world continue to inspire modern architects and engineers",
    "Eight experienced musicians performed a beautiful classical symphony for the appreciative evening audience",
    "Nine months of intensive training prepared the athletes for the upcoming international competition",
    "Ten commandments provide moral guidance for people seeking spiritual direction in their daily lives",
    "Human rights organizations work diligently to protect vulnerable populations around the world",
    "Every person deserves equal opportunities regardless of their background, culture, or personal circumstances",
    "Big dreams require persistent effort, unwavering determination, and the support of caring friends",
    "Large corporations have significant responsibilities to their employees, customers, and local communities",
    "Great leaders inspire others through their actions rather than merely their words or promises",
    "Each day brings new possibilities for learning, growing, and making positive contributions to society",
    "The sun provides essential energy for all life on our planet through photosynthesis processes",
    "Japan has successfully maintained its cultural traditions while embracing technological innovation and modernization",
    "The year ahead promises exciting opportunities for professional development and personal growth experiences",
    "Age brings wisdom through accumulated experiences, but youth brings energy and fresh perspectives",
    "The exit strategy required careful planning and consideration of all stakeholders and potential consequences",
    "Come out of your comfort zone to discover hidden talents and unexplored possibilities",
    "Go out into the world with confidence, curiosity, and compassion for others",
    "Book reading expands vocabulary, improves concentration, and provides entertainment during leisure time",
    "The origin of many cultural practices can be traced back centuries through historical records",
    "Main objectives should be clearly defined before beginning any complex project or undertaking",
    "Middle ground solutions often provide the most sustainable and acceptable compromises for everyone",
    "Inside knowledge gives experienced professionals significant advantages in competitive business environments",
    "The center stage performance showcased years of dedicated practice and natural artistic talent",
    "Every child deserves love, protection, and opportunities to reach their full potential in life",
    "Offspring naturally inherit both genetic traits and learned behaviors from their parents and family",
    "See the world through different perspectives to develop empathy and cultural understanding",
    "Look both ways before making important decisions that will affect your future happiness",
    "Watch your language when speaking to others, as words have the power to heal or hurt",
    "Country music tells stories of ordinary people facing life's challenges with courage and determination",
    "The nation stands united during times of crisis, demonstrating the strength of democratic values",
    "Above average performance requires consistent effort, continuous learning, and professional dedication",
    "Up the corporate ladder advancement depends on merit, integrity, and collaborative teamwork skills",
    "Top shelf quality products command premium prices but provide superior customer satisfaction and loyalty",
    "Part of being successful involves learning from failures and maintaining a positive attitude",
    "Minute details often make the difference between mediocre results and truly exceptional achievements",
    "Divide complex problems into manageable parts to find effective solutions more efficiently",
    "Life goes on after setbacks, offering new chances for happiness and personal fulfillment",
    "Birth certificates serve as official documentation of identity and citizenship for legal purposes",
    "Raw materials must be carefully processed to create high-quality finished products for consumers",
    "Go home to family and friends who provide emotional support and unconditional love",
    "Conduct business meetings with professionalism, respect, and clear communication objectives in mind",
    "The line between right and wrong becomes clearer through moral education and ethical reflection",
    "Between different options, choose the path that aligns with your values and long-term goals",
    "Time interval training improves cardiovascular fitness more effectively than steady-state exercise routines",
    "Time flies when you are engaged in meaningful work that contributes to something greater",
    "Hour-long meditation sessions can reduce stress and improve mental clarity significantly over time",
    "The spirit of adventure motivates explorers to discover new territories and expand human knowledge",
    "Mind over matter philosophy teaches that mental strength can overcome many physical limitations",
    "Feeling good about yourself requires self-acceptance, personal growth, and healthy relationships with others",
    "Woman of strength overcomes obstacles through perseverance, intelligence, and emotional resilience",
    "Female leadership brings unique perspectives and collaborative approaches to organizational management challenges",
    "Before sunrise, many people enjoy peaceful moments of reflection and preparation for the day ahead",
    "Front row seats provide the best view but also the greatest responsibility to engage respectfully",
    "Enter your password carefully to protect personal information and maintain cybersecurity for everyone",
    "Put in maximum effort to achieve your goals while maintaining balance and personal well-being",
    "Small town charm offers a slower pace of life and stronger community connections",
    "Little gestures of kindness can have profound impacts on other people's lives and happiness",
    "After work activities help maintain work-life balance and provide opportunities for personal interests",
    "Behind every successful person are mentors, supporters, and loved ones who believed in them",
    "Later this evening, families will gather around dinner tables to share stories and strengthen bonds",
    "Long journey adventures require careful planning, appropriate equipment, and flexible scheduling arrangements",
    "Chief executive officers bear ultimate responsibility for organizational success and stakeholder satisfaction",
    "Leadership requires vision, integrity, empathy, and the ability to inspire others toward common goals",
    "Below sea level communities face unique challenges from flooding and require specialized infrastructure solutions",
    "Down payment savings demonstrate financial responsibility and commitment to major purchase decisions",
    "Under pressure situations reveal character traits and decision-making abilities that define true leadership",
    "Study habits developed during youth create foundations for lifelong learning and intellectual curiosity",
    "Learning opportunities exist everywhere for those who maintain open minds and curious attitudes",
    "Science education prepares students to think critically about evidence and make informed decisions",
    "The month of celebration brings families together to honor traditions and create lasting memories",
    "Moon phases affect ocean tides and have inspired human cultures throughout recorded history",
    "What matters most in life cannot be measured in monetary terms or material possessions",
    "How many opportunities do we miss because we are afraid to take calculated risks",
    "Come here and experience the warmth of genuine hospitality and community spirit firsthand",
    "Next generation leaders must address climate change, inequality, and technological disruption challenges effectively",
    "Future success depends on adapting to change while maintaining core values and ethical principles",
    "Speak your truth with courage and conviction while respecting others' perspectives and experiences",
    "Talk therapy provides safe spaces for people to process emotions and develop coping strategies",
    "Story telling preserves cultural heritage and passes wisdom from one generation to the next",
    "Mountain climbing teaches perseverance, risk assessment, and the rewards of achieving challenging goals",
    "Hill country landscapes offer scenic beauty and opportunities for outdoor recreation and reflection",
    "High expectations motivate excellence but must be balanced with compassion and realistic assessment",
    "Tall buildings symbolize human ambition and engineering capabilities while creating urban density challenges",
    "Expensive mistakes teach valuable lessons about careful planning and thorough risk analysis",
    "Now is the perfect time to begin pursuing your dreams with determination and strategic planning",
    "Present moment awareness helps reduce anxiety and increases appreciation for life's simple pleasures",
    "Write down your goals to increase accountability and track progress toward achieving desired outcomes",
    "Name recognition builds through consistent quality work and positive contributions to community welfare",
    "Famous personalities have platforms to influence positive social change and inspire others",
    "Gold standard excellence requires continuous improvement, attention to detail, and customer focus",
    "Money management skills enable financial security and the ability to support charitable causes",
    "Metal recycling reduces environmental impact while creating economic opportunities for local communities",
    "Man and woman partnerships succeed through mutual respect, clear communication, and shared values",
    "Male and female perspectives both contribute essential insights to balanced decision-making processes",
    "Outside influences should be considered carefully but not allowed to override personal values and judgment",
    "Foreign language learning opens doors to cross-cultural understanding and international career opportunities",
    "Before making major decisions, consult trusted advisors and consider long-term consequences carefully",
    "Ahead of schedule completion demonstrates efficiency and creates opportunities for additional value creation",
    "Previous experience provides valuable context but should not limit openness to new approaches and innovations",
    "River conservation protects ecosystems and ensures clean water supplies for future generations' well-being",
    "Stream of consciousness writing can unlock creativity and help process complex emotions and thoughts",
    "East coast culture differs from west coast in pace, values, and lifestyle preferences significantly",
    "West wind patterns influence weather systems and have shaped historical navigation and trade routes",
    "South American countries share cultural similarities while maintaining distinct national identities and traditions",
    "North American integration creates economic opportunities while respecting national sovereignty and cultural differences",
    "Left and right political perspectives both offer valuable insights for balanced democratic governance",
    "Right decisions often require courage to do what is morally correct despite potential personal costs",
    "Water conservation efforts protect precious natural resources for future generations and ecosystem health",
    "Fire safety education prevents tragedies and protects lives, property, and natural environments from destruction",
    "Tree planting initiatives combat climate change while beautifying communities and providing wildlife habitat",
    "Flower gardens bring beauty, attract beneficial insects, and provide peaceful spaces for meditation and reflection",
  ],

  long: [
    "Every single morning I wake up very early and go for an energizing run through the peaceful neighborhood before having a healthy breakfast with my loving family members",
    "The magnificent ancient castle stood majestically on top of the steep hill, overlooking the charming small village where many generations of families had lived peacefully for countless centuries",
    "During our wonderful vacation last summer, we visited many interesting places including fascinating museums, art galleries, and historical sites that taught us about local culture and traditions",
    "The dedicated scientist spent many years researching renewable energy sources and finally discovered a breakthrough method that could revolutionize how we power our modern cities",
    "After graduating from university with highest honors, she decided to travel around the entire world to learn about different cultures and languages before starting her professional career",
    "The small bookstore on the corner of Main Street has been serving the community for over fifty years, providing not just books but also a place for people to gather and discuss literature",
    "Despite facing many challenges and obstacles along the way, the young entrepreneur never gave up on his dream of starting a company that would help solve environmental problems",
    "The cooking class taught us how to prepare traditional dishes from various countries, including techniques for selecting fresh ingredients and balancing flavors perfectly",
    "As the seasons changed from autumn to winter, the forest transformed into a magical wonderland covered in snow, creating breathtaking scenery that attracted photographers from around the world",
    "The research team worked tirelessly for months to develop a new medicine that could help millions of patients recover faster from serious illnesses while reducing harmful side effects significantly",

    // Additional comprehensive long sentences covering all translations
    "The first international conference on sustainable development brought together world leaders, environmental scientists, and community organizers to discuss innovative solutions for combating climate change while promoting economic growth and social justice in developing nations around the globe",
    "One remarkable discovery made by the research team revealed that combining traditional medicine with modern technology could significantly improve patient outcomes while reducing healthcare costs and making treatments more accessible to underserved populations in rural and urban communities worldwide",
    "Two different educational approaches were carefully compared over the course of five years, and the results demonstrated that personalized learning methods combined with collaborative group activities produced significantly better academic outcomes and higher student satisfaction rates than traditional lecture-based instruction models",
    "The second phase of the urban renewal project focused on creating affordable housing options while preserving historical architecture and community character, involving extensive consultation with local residents, business owners, and cultural organizations to ensure that development plans reflected the diverse needs and values of the neighborhood",
    "Three generations of the same family worked together to establish a sustainable farming operation that not only provided healthy food for their local community but also served as an educational center where children and adults could learn about organic agriculture, environmental stewardship, and the importance of preserving traditional farming knowledge",
    "The third annual music festival showcased the incredible diversity of cultural traditions in the region, featuring performances by artists representing dozens of different ethnic communities and musical styles, while also providing educational workshops, art exhibitions, and food vendors that celebrated the rich heritage and contemporary creativity of the local population",
    "Four major technological innovations developed over the past decade have revolutionized the way people communicate, learn, work, and entertain themselves, fundamentally changing social interactions and creating both opportunities and challenges that require careful consideration of privacy, security, and digital equity issues in our increasingly connected world",
    "Five essential principles of effective leadership include developing emotional intelligence, fostering inclusive environments, communicating with clarity and authenticity, making decisions based on ethical considerations and available evidence, and continuously learning from both successes and failures while remaining adaptable to changing circumstances and emerging challenges",
    "Six months of intensive community organizing efforts resulted in the successful passage of legislation that expanded access to mental health services, increased funding for public transportation, and established new environmental protection standards, demonstrating the power of grassroots democracy and citizen engagement in creating positive social change",
    "Seven different renewable energy technologies were evaluated by the engineering team to determine which combination would provide the most reliable, cost-effective, and environmentally sustainable power generation system for the region, taking into account local weather patterns, geographical features, infrastructure requirements, and long-term maintenance considerations",
    "Eight experienced teachers collaborated to develop an innovative curriculum that integrates science, technology, engineering, arts, and mathematics education while emphasizing critical thinking, creative problem-solving, and real-world application of knowledge, resulting in significantly improved student engagement and achievement across diverse socioeconomic backgrounds",
    "Nine months of careful planning, community consultation, and environmental impact assessment preceded the groundbreaking ceremony for the new public library, which was designed to serve as both an information resource center and a community gathering place where people of all ages and backgrounds could access books, technology, educational programs, and cultural events",
    "Ten fundamental human rights recognized by international law include the right to life, liberty, and security of person; freedom from discrimination and persecution; access to education, healthcare, and adequate housing; freedom of expression and peaceful assembly; and the right to participate in democratic governance and fair legal proceedings that protect individual dignity and promote social justice",
    "Every human being possesses inherent dignity and worth that transcends cultural differences, economic status, or personal circumstances, and this recognition forms the foundation for building inclusive societies where everyone has opportunities to develop their potential, contribute to community welfare, and live with freedom, security, and respect from others",
    "The person who dedicates their life to serving others through teaching, healthcare, social work, or community leadership demonstrates the highest ideals of human compassion and civic responsibility, creating positive ripple effects that extend far beyond their immediate sphere of influence and inspire others to contribute to the common good",
    "Big changes in society often begin with small actions taken by ordinary individuals who recognize problems in their communities and decide to work toward solutions, organizing neighbors, advocating for policy improvements, starting nonprofit organizations, or simply treating others with greater kindness and respect in their daily interactions",
    "Large-scale environmental challenges require coordinated responses from governments, businesses, educational institutions, and individual citizens working together to implement sustainable practices, develop clean technologies, protect natural habitats, and create economic systems that prioritize long-term ecological health over short-term profits",
    "Great achievements in science, art, literature, and social progress result from the accumulated efforts of countless individuals across generations who built upon previous knowledge, challenged existing assumptions, experimented with new ideas, and persevered through failures and setbacks to expand human understanding and capability",
    "Each day presents opportunities to make choices that reflect our values and priorities, whether through the work we do, the relationships we nurture, the communities we support, or the small acts of kindness and consideration that contribute to creating a more compassionate and just world for current and future generations",
    "The sun provides not only the energy that sustains all life on Earth through photosynthesis and weather systems, but also serves as a powerful symbol across cultures for renewal, hope, enlightenment, and the cyclical nature of existence, inspiring countless works of art, literature, and spiritual reflection throughout human history",
    "Japan successfully demonstrates that nations can honor their cultural heritage and traditional values while embracing technological innovation, international cooperation, and social progress, creating a unique synthesis that contributes to global understanding and demonstrates multiple pathways to prosperity and human development",
    "The year ahead offers countless possibilities for personal growth, professional development, community engagement, and positive contribution to addressing the major challenges facing humanity, including climate change, social inequality, technological disruption, and the need for greater understanding and cooperation among diverse peoples and cultures worldwide",
    "Age brings not only the wisdom gained through decades of lived experience, but also the responsibility to share knowledge with younger generations while remaining open to new ideas and perspectives that can enhance understanding and contribute to continued learning and personal development throughout all stages of life",
    "The exit from traditional ways of thinking and working requires courage, creativity, and careful planning to navigate transitions successfully while maintaining stability and security for families, communities, and organizations that depend on reliable structures and predictable outcomes during periods of change and uncertainty",
    "Coming out of your comfort zone to explore new territories, whether geographical, intellectual, social, or spiritual, often leads to unexpected discoveries about yourself and the world, expanding your capacity for empathy, understanding, and appreciation of the rich diversity of human experience and natural beauty",
    "Going out into the world with an attitude of curiosity, compassion, and respect for others creates opportunities to learn from different cultures, form meaningful relationships, contribute to positive change, and develop a broader perspective on the challenges and opportunities facing humanity in our interconnected global community",
    "Book reading remains one of the most powerful tools for expanding vocabulary, improving concentration, developing empathy through exposure to diverse characters and situations, accessing accumulated human knowledge and wisdom, and providing entertainment and inspiration during both leisure time and periods of difficulty or uncertainty",
    "The origin of many contemporary social movements, technological innovations, and cultural practices can be traced back through historical records to earlier periods when visionary individuals recognized problems or possibilities and began organizing efforts to create positive change, often facing significant resistance before their ideas gained broader acceptance",
    "Main Street businesses serve as the economic and social backbone of communities across the country, providing essential goods and services, creating local employment opportunities, supporting community events and organizations, and fostering the personal relationships and shared experiences that build social cohesion and civic engagement",
    "Middle ground solutions to complex problems often require extensive dialogue, compromise, and creative thinking to identify approaches that address the legitimate concerns and interests of all stakeholders while avoiding the polarization and conflict that can arise from rigid adherence to extreme positions on either side of contentious issues",
    "Inside knowledge of how systems work, whether in business, government, education, or other institutions, provides individuals with advantages in navigating these environments effectively, but it also creates ethical responsibilities to use this information in ways that promote fairness, transparency, and positive outcomes for all participants",
    "The center stage of democratic participation is not limited to voting in elections, but includes ongoing civic engagement through community organizing, public advocacy, volunteer service, informed discussion of public issues, and the everyday actions that demonstrate commitment to the values of equality, justice, and mutual respect",
    "Every child born into this world possesses unlimited potential for learning, creativity, compassion, and positive contribution to society, but realizing this potential requires nurturing environments, quality education, healthcare access, family stability, and communities that value diversity and provide opportunities for all young people to develop their unique talents and abilities",
    "Offspring inherit not only genetic characteristics from their parents, but also cultural values, behavioral patterns, and social expectations that shape their worldview and life choices, making it essential for each generation to thoughtfully examine these inherited influences and consciously decide which traditions to preserve, modify, or replace",
    "Seeing the world through multiple perspectives requires actively seeking out viewpoints different from your own, listening with genuine curiosity to others' experiences and opinions, questioning your assumptions and biases, and remaining humble about the limitations of any single person's understanding of complex social, political, and environmental issues",
    "Looking ahead to the future with both hope and realism requires acknowledging the serious challenges facing humanity while also recognizing the tremendous capacity for innovation, cooperation, and positive change that exists when people work together with shared purpose, adequate resources, and commitment to evidence-based solutions",
    "Watching over our natural environment means accepting responsibility for protecting ecosystems, reducing pollution and resource consumption, supporting sustainable business practices, and making lifestyle choices that demonstrate respect for the interconnected web of life that sustains all species on our shared planet Earth",
    "Country music, folk traditions, and other forms of cultural expression preserve the stories, values, and experiences of different communities and historical periods, providing insight into how people have faced universal challenges of love, loss, work, family, and the search for meaning and belonging across diverse geographical and social contexts",
    "The nation's strength lies not in military power or economic dominance, but in the character of its people, the justice of its institutions, the inclusiveness of its democracy, and its commitment to principles of human rights, environmental stewardship, and international cooperation that promote peace and prosperity for all peoples",
    "Above all considerations of personal advancement or material gain, the most meaningful life choices are those guided by compassion for others, commitment to truth and justice, respect for the natural world, and dedication to leaving a positive legacy for future generations through both individual actions and collective efforts to address shared challenges",
  ],
};
